$(document).ready(function(){
	var clipboard = new ClipboardJS('.clipboard');
	clipboard.on('success', function(e){
		// console.info('Action:', e.action);
		// console.info('Text:', e.text);
		// console.info('Trigger:', e.trigger);

		// e.clearSelection();
		alert('Copied');
	});

	// BOOTSTRAP SWITCH
	$('.cool_switch')['bootstrapSwitch']();

	// TableSorter
	$(".tablesorter").tablesorter();
	
	//sevenup
	//sevenUp.plugin.black.test( { showToAllBrowsers: false }, false);
	
	//fullPage.js
	//$.fn.fullpage();

	//$(window).stellar();
	
	/***************************/
	//redesign .html() function
	/***************************/
	
	// create a reference to the old `.html()` function
	var htmlOriginal = $.fn.html;
	
	// redefine the `.html()` function to accept a callback
	$.fn.html = function(html,callback){
	  // run the old `.html()` function with the first parameter
	  var ret = htmlOriginal.apply(this, arguments);
	  // run the callback (if it is defined)
	  if(typeof callback == "function"){
	    callback();
	  }
	  // make sure chaining is not broken
	  return ret;
	}
	/***************************/
	// THEME SELECTOR
	$('#theme-selector a').click(function(){
		mytheme = $(this).attr('theme');
		$('body').removeClass().addClass('theme '+mytheme);
		$('#theme-selector a').removeClass('active');
		$(this).addClass('active');

		$.ajax({
			type	:	"GET",
			url		:	"ajax.php",
			data	:	{command: "selectTheme", theme: mytheme},
			success	:	function(data){
				console.log(data);
			}

		})
	});

	/***************************/
	call_exist = $('#therapist_call').length;
	if(call_exist){
		interval = setInterval(function(){
			branch = $('input[name=branch]').val();
			hash = $('input[name=hash]').val();
			$.ajax({
				type		:	"POST",
				url			:	"ajax.php?p=call&b="+branch,
				data		:	{command: "therapistCall"},
				dataType	:	"json",
				beforeSend	:	function(){
					$('#therapist_call').append("<div class='main loading black'></div>");
				},
				success		:	function(data){
					unload();
					hash = $('input[name=hash]').val();
					if(hash == data.hash){
					}else{
						$('.dropzone').fadeOut(100, function(){
							$(this).html(data.show).fadeIn();
						});
						$('input[name=hash]').val(data.hash);
					}
					$('#therapist_call .status').html(data.update);
				}
			});
		}, 10000);
	}
	
	$('#therapist_call button.refresh').click(function(){
		branch = $('input[name=branch]').val();
		hash = $('input[name=hash]').val();
		$.ajax({
			type		:	"POST",
			url			:	"ajax.php?p=call&b="+branch,
			data		:	{command: "therapistCall"},
			dataType	:	"json",
			beforeSend	:	function(){
				$('#therapist_call').append("<div class='main loading black'></div>");
			},
			success		:	function(data){
				unload();
				hash = $('input[name=hash]').val();
				if(hash == data.hash){
				}else{
					$('.dropzone').fadeOut(100, function(){
						$(this).html(data.show).fadeIn();
					});
					$('input[name=hash]').val(data.hash);
				}
				$('#therapist_call .status').html(data.update);
			}
		});
	});

	$('#upload-form .import-button').click(function(){
		file_input = $(this).parent().find('input[type="file"]');
		if(file_input.val() == ''){
			return false;
		}else{
			return true;
		}
	});

	// Payroll Approve
	setPayrollButton();
	function setPayrollButton(){
		// DASHBOARD
		payroll_dashboard_exist = $('#admin.payroll_approve_dashboard').length;
		if(payroll_dashboard_exist){
			$('.payroll-approve-detail-sign .fa').click(function(e){
				loading();
				type = $(this).parent().attr("type");
				branch_id = $(this).parent().attr("branch");

				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "payroll-approve-detail", type: type, branch_id: branch_id},
					success	:	function(data){
						unload();
						toolltips(data, e);
					}
				});
			});
		}

		// APPROVE BUTTON
		payroll_approve_exist = $('#payroll-approve').length;
		payroll_range_select_exist = $('#payroll-range-select').length;
		if(payroll_approve_exist || payroll_range_select_exist){
			// RANGE SELECT
			$('button[name=payroll-range-select]').click(function(){
				loading();

				// VARS
				transaction_type = $(this).attr('transaction_type');
				range_type = $(this).val();

				// ANIMATION
				$('button[name=payroll-range-select]').not(':disabled').find('.fa').removeClass('fa-check-square-o').addClass('fa-square-o');
				$(this).find('.fa').removeClass('fa-square-o').addClass('fa-check-square-o');

				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "payroll-range-select", transaction_type: transaction_type, range_type: range_type},
					success	:	function(data){
						window.location.reload();
						unload();
					}
				});
			});

			// APPROVE BUTTON
			$('button[name=payroll-approve]').click(function(){
				// VARS
				transaction_type = $(this).val();

				// ANIMATION
				button = $(this);
				button.find('.fas').addClass('fa-spin');

				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "payroll-approve", transaction_type: transaction_type},
					success	:	function(data){
						setTimeout(function(){
							button.find('.fas').removeClass('fa-spin').removeClass('fa-check-circle-o').parent().parent().fadeOut(100, function(){
								button.parent().html(data).fadeIn(200, function(){
									setPayrollButton();
								});
							});
						}, 1000);
					}
				});
			});
		}
	}	

	// CONTRACT FORM
	contract_exist = $('form[name=contract_form]').length;
	if(contract_exist){
		if($('.radio_balance').is(':checked')){
			$('.input_credit').hide();
			$('.input_balance').show();
		}else{
			$('.input_credit').fadeIn();
		}
		$('.radio_credit').click(function(){
			$('.input_credit').show();
		});
		$('.radio_balance').click(function(){
			$('.input_credit').hide();
			$('.input_balance').show();
		});
	}

	/***************************/

	// DEPOSIT
	$('form[name=deposit_form]').submit(function(){
		// CHECK RADIO
		if($('#deposit_radio').is(':checked') || $('#credit_radio').is(':checked')){
			if(requireCheck()){
				if(confirm("Submit deposit/credit amount?")){
					return true;
				}else{
					return false;
				}
			}else{
				return false;
			}
		}else{
			alert("Please choose transfer type.");
			return false;
		}
	});

	$('form[name=credit_form]').submit(function(){
		if(confirm("Reset Credit?")){
			return true;
		}else{
			return false;
		}
	});

	$('button#close_account').click(function(){
		if(confirm("Close this Contract Account?")){
			city_id = $(this).attr('city_id');
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "closeContractAccount", city_id: city_id},
				success	:	function(){
				}
			});

			// REFRESH AFTER AJAX STOP
			$(document).ajaxStop(function(){
			    window.location.reload();
			});
		}else{
			return false;
		}
	});
	
	$('.deposit_delete').click(function(){
		if(confirm("Delete this deposit?")){
			deposit_id = $(this).attr("deposit_id");
			$.ajax({
				type		:	"POST",
				url			:	"ajax.php",
				data		:	{command: "deposit_delete", deposit_id: deposit_id},
				dataType	:	"json",
				success		:	function(){
					
				}
			});

			// REFRESH AFTER AJAX STOP
			$(document).ajaxStop(function(){
			    window.location.reload();
			});
		}
	});
	
	// stock_debit payment_date
	stock_debit_payment_exist = $('.stock_debit input[name=payment_date]').length;
	if(stock_debit_payment_exist){
		// first run
		date = $('.stock_debit input[name=payment_date]').val();
		checkFinalApproveStockDebit(date);

		// blind
		$('.stock_debit input[name=payment_date]').change(function(){
			date = $(this).val();
			checkFinalApproveStockDebit(date);
		});
	}
	// delivery_transfer
	delivery_date_exist = $('.delivery_transfer input[name=delivery_date]').length;
	if(delivery_date_exist){
		// first run
		date = $('.delivery_transfer input[name=delivery_date]').val();
		checkFinalApproveStockDebit(date);

		// blind
		$('.delivery_transfer input[name=delivery_date]').change(function(){
			date = $(this).val();
			checkFinalApproveStockDebit(date);
		});
	}

	// delivery receive
	receive_date_exist = $('.delivery input[name=receive_date]').length;
	if(receive_date_exist){
		// first run
		date = $('.delivery input[name=receive_date]').val();
		checkFinalApproveStockDebit(date);

		// blind
		$('.delivery input[name=receive_date]').change(function(){
			date = $(this).val();
			checkFinalApproveStockDebit(date);
		});
	}
	
	setNumberOnly();
	
	$('.sub_tab a').click(function (e) {
		e.preventDefault()
		$(this).tab('show')
	})
    
    $('.announce_close').click(function(){
/*
	    if(confirm("จะปิดทำไมอุตส่าห์เตือน ยังจะปิดอยู่มั้ย?")){
	    	$('.announce.sexy').fadeOut().remove();
	    }
*/
	    $('.announce.sexy').fadeOut().remove();
    });
    
    limit_view_report_days = $('input[name=limit_view_report_days]').val();
    if(limit_view_report_days == 0){
	    limit_view_report_days = new Date(2014, 1 - 1, 1);
    }else{
	    limit_view_report_days = -limit_view_report_days;
    }

	// FOR ISBS
	bookingPicker();
    
    $('.date_input').datepicker({
		dateFormat:'yy-mm-dd',
		changeMonth: true,
		changeYear: true,
		minDate: limit_view_report_days,
		maxDate: "+2y"
	});

	$('.date_input_no_limit').datepicker({
		dateFormat:'yy-mm-dd',
		changeMonth: true,
		changeYear: true,
	});

	$('.birth_date_input').datepicker({
		dateFormat:'yy-mm-dd',
		changeMonth: true,
		changeYear: true,
		yearRange: "c-90:c-8"
	});

    $('.month_input').datepicker({
		changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        dateFormat: 'MM yy',
        minDate: limit_view_report_days,
        // maxDate: 0,
        onClose: function(dateText, inst) { 
            var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
            var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
            $(this).datepicker('setDate', new Date(year, month, 1));
            
            vars = $('#filter_form').serializeArray();
			command = $('input[name=command]').val();
			console.log(vars);
			console.log("-----month_input | command: "+command+"-----");
			$.ajax({
				type		:	"POST",
				url			:	"ajax.php",
				data		:	vars,
				beforeSend	:	function(){
					loading();
				},
				success		:	function(data){
					unload();
					if(data == true){
						window.location.reload();
					}else{
						$('.dropzone').html(data);
						setVoidPage();//setting
						setApprove();
						setPayrollButton();
					}
				}
			});
        },
        beforeShow: function(input, inst) {
	       $('#ui-datepicker-div').addClass("month-calendar");
	   }
	});
	
	$('.time_input').timepicker({
		"showCloseButton"	:	true
	});

	// MAX AMOUNT
	$('input[max-amount]').change(function(){
		if(parseInt($(this).val()) > parseInt($(this).attr('max-amount'))){
			alert('exceed amount');
			$(this).val(parseInt($(this).attr('max-amount')));
		}
	});

	// WHATTTTT?
	if($('input[name=quick_booking]').val() == 'true'){
		// SKIP
	}else{
		today = Date.today();
		treatment_date = $.datepicker.formatDate('yy-mm-dd', today);
		$('input[name=treatment_date]').val(treatment_date);
	}
	
	path = $('input[name=site_url]').val();
	
	confirm_delete = "Do you really wnat to delete this entry?";
	confirm_change_page = "Change page will lost the current selections, continue?";
	
	$('.sortable').sortable({
		placeholder: "ui-state-highlight",
		stop	:	function(){
			// reQueue();
		}
	});

	
	//card
	card_transfer_form_exist = $('#card_transfer').length;
	if(card_transfer_form_exist){
		$('.auto_smart_card').mousedown(function(){
			$(this).val("");
		});
		$('.auto_smart_card').autocomplete({
			source: path+"ajax_autocomplete.php?type=smart_card",
			minLength: 1,
			autoFocus: true,
			change:	function(event, ui){
			},
			close: function(event, ui){
				smartcard_code = $(this).val();
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "getsmartcarddetail", smartcard_code: smartcard_code},
					success	:	function(data){
						$('.smart_card_information').html(data);
					}
				});
			}
		});
		$('#card_transfer_form').submit(function(){
			has_card = $('#current_card').length;
			if(has_card){
				if(requireCheck()){
					if(confirm("Proceed card transfer?")){
						return true;
					}else{
						return false;
					}
				}else{
					return false;
				}
			}else{
				alert("please scan card");
				return false;
			}
		});
	}
	card_detail_exist = $('#card_detail').length;
	if(card_detail_exist){
		$('.auto_card').mousedown(function(){
			$(this).val("");
		});
		$('.auto_card').autocomplete({
			source: path+"ajax_autocomplete.php?type=card",
			minLength: 1,
			autoFocus: true,
			change:	function(event, ui){
			},
			select: function(event, ui){
				card_id = ui.item.card_id;
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "getcarddetail", card_id: card_id},
					success	:	function(data){
						$('#card_detail').remove();
						$('#admin_menu').after(data);
					}
				});
			}
		});
	}
	create_card_form_exist = $('#create_card_form').length;
	if(create_card_form_exist){
		max_allow_create_card = $('input[name=max_allow_create_card]').val();
		$('.create_card_amount').keyup(function(){
			amount = $(this).val();
			if(parseInt(amount) > parseInt(max_allow_create_card)){
				alert("Maximun cards allow : "+max_allow_create_card+" cards");
				$(this).val("");
			}
		});
	}
	card_register_exist = $('#card_register').length;
	if(card_register_exist){
		register_mode = "new";
		$('.new_member_button').click(function(){
			register_mode = "new";
			$('#register_member').fadeIn();
			$('#exist_member').fadeOut(200);
		});
		$('.exist_member_button').click(function(){
			register_mode = "exist";
			$('#exist_member').fadeIn();
			$('#register_member').fadeOut(200);
		});
		
		$('#exist_member, #register_member').submit(function(){
			has_card = $('#current_card').length;
			if(has_card){
				if(requireCheck()){
					// CHECK PIN
					pin = $('input[name=pin-code]:visible').val();
					retype_pin = $('input[name=retype-pin-code]:visible').val();
					// alert(pin+" | "+retype_pin);
					if(pin == retype_pin && pin != ""){
						pin_length = pin.replace(/ /g,'').length
						if(pin_length == 4){
							if(register_mode == "exist"){
								// DO NOT CHECK EMAIL
								if(confirm("Proceed card registration?")){
									return true;
								}else{
									return false;
								}
							}else{
								// CHECK EMAIL
								email = $('input[name=email]').val();
								if(email != ''){
									is_email = isValidEmailAddress(email);
									if(is_email){
										if(confirm("Proceed card registration?")){
											return true;
										}else{
											return false;
										}
									}else{
										alert("คุณป้อน email ไม่ถูกต้อง กรุณาตรวจเช็คอีกครั้ง");
										return false;
									}
								}else{
									if(confirm("Proceed card registration?")){
										return true;
									}else{
										return false;
									}
								}
							}
						}else{
							alert("PIN length must be 4 characters long.");
							return false;
						}
					}else{
						alert("PIN ทั้ง 2 ช่องไม่ตรงกัน");
						return false;
					}
				}else{
					return false;
				}
			}else{
				alert("please scan card");
				return false;
			}
		});
	}
	$('.button-show-inactive').click(function(){
		$('.view_user tr.danger').show();
	});
	$('.reset_fail_button').click(function(){
		if(confirm('Reset fail count for this user?')){
			user_id = $(this).attr('user_id');
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "reset_fail_count", user_id: user_id},
				success	:	function(data){
					window.setTimeout('location.reload()', 0);
				}
			});
		}else{
			return false;
		}
	});
	$('.unblock_ip_button').click(function(){
		if(confirm('Unblock this IP?')){
			ban_id = $(this).attr('ban_id');
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "unblock_ip", ban_id: ban_id},
				success	:	function(data){
					window.setTimeout('location.reload()', 0);
				}
			});
		}else{
			return false;
		}
	});

	// SALE REPORT APPROVE
	sale_approve_exist = $('#report.sale').length;
	if(sale_approve_exist){
		setSaleReportApprove();
	}
	function setSaleReportApprove(){
		$('button[name=sale_report_approve]').click(function(){
			loading();
			approve_button = $('button[name=sale_report_approve]');
			transaction_date = $('input[name=transaction_date]').val();
			branch_id = $('input[name=branch_id]').val();
			$.ajax({
				"type"		:	"POST",
				"url"		:	"ajax.php",
				"dataType"	:	"json",
				"data"		:	{command: "sale_report_approve", transaction_date: transaction_date, branch_id: branch_id},
				beforeSend	:	function(){
					approve_button.attr("disabled", "disabled");
				},
				success		:	function(data){
					unload();
					if(data.pass){
						$('.approve_box').html("<div class='announce success'>Success</div>");
					}else{
						$('.approve_box #replace_box').html("<div class='announce error box'>Failed</div><div class='announce mini warning'>"+data.message+"</div>"+data.debug);
						approve_button.prop("disabled", false);

						// DEBUG DIFF
						$('.approve_box').append(data.debug_diff);
					}
				}
			});
		});
	}
	
	// ADMIN APPROVE
	approve_exist = $('#approve').length;
	if(approve_exist){
		setApprove();
	}
	function setApprove(){
		$('button[name=approve_button]').click(function(){
			branch_id = $(this).attr("branch_id");
			approve_system_id = $(this).attr("approve");
			// if(confirm("Confirm approve?")){
			if(password = prompt("Confirm approval by input your password?", "")){
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					dataType:	"json",
					data	:	{command: "approve", approve_system_id: approve_system_id, branch_id: branch_id, password: password},
					success	:	function(data){
						// console.log(data);
						if(data.pass){
							$('.dropzone').html(data.show);
							setApprove();
						}else{
							alert(data.text);
						}
					}
				});
			}
		});
	}

	// STOCK LAB SCANNER
	scanproduct_exist = $('#scanProduct').length;
	if(scanproduct_exist){
		$(window).scannerDetection({
			timeBeforeScanTest	:	300, // tolerate mid-scan gaps (long codes)
			function(){
				loading()
			},
			// onReceive	:	function(code){
			// 	$('.dropzone').html('');
			// },
			onError		:	function(code){
				unload();
			},
			onComplete	:	function(code){
				unload();

				// SCANCHECK
				$.ajax({
					url		:	"ajax.php",
					data	:	{command: "scanCheckInfo", code: code},
					dataType:	"json",
					type	:	"POST",
					beforeSend	:	function(){
						loading();
					},
					success	:	function(data){
						unload();
						console.log(data);
						if(data.status){
							if(data.show){
								$('.dropzone').html(data.show);
							}else{
								$('.dropzone').html('<div class="announce info">'+data.type+'</div>');
							}
						}else{
							$('.dropzone').html('<div class="announce error">'+data.message.th+'<br>'+data.message.en+'</div>');
						}
					}
				});
			}
		});
	}
	
	// PIN RESET REQUEST
	pin_request_exist = $('#admin.pin_request').length;
	if(pin_request_exist){
		setPINButton();
	}

	$('#filter .select_brand').not('#report #filter .select_brand').change(function(){ // #report : QUERY ON GO BUTTON
		brand = $(this).val();
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "changeBrand", brand:brand},
			beforeSend : function(){
				loading();
			},
			success	:	function(data){
				$('.page_body').html('<div class=\'announce success\'>changing brand</div>');
				window.setTimeout('location.reload()', 500);
			}
		});
	});

	$('#filter .select_guide_type').change(function(){
		guide_type = $(this).val();
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "changeGuideType", guide_type:guide_type},
			beforeSend : function(){
				loading();
			},
			success	:	function(data){
				window.setTimeout('location.reload()', 500);
			}
		});
	});

	// THERAPIST
	$('#therapist_class').change(function(){
		class_id = $(this).val();

		// GET LEVEL
		$.ajax({
			type		:	"POST",
			url		:	"ajax.php",
			data		:	{command: "getTherapistLevel", class_id: class_id},
			success	:	function(data){
				$('#therapist-level-dropzone').html(data);
			}
		});
	});
	
	//therapist transfer
	transfer_therapist_exist = $('.transfer_therapist').length;
	if(transfer_therapist_exist){
		setTherapistButton();
	}
	function setTherapistButton(){
		$('#transfer_therapist_form button[name=submit_transfer]').click(function(){
			if(
				($('#is_base_yes').is(':checked') || $('#is_base_no').is(':checked')) && $('input[name=therapist_id]').val() != ''
			){
				if(
					($('select[name=to_branch_id]').val() != "" && $('input[name=start_time]').val() != "") ||
					($('select[name=to_branch_id]').val() == "" && $('input[name=start_time]').val() == "")
				){
					//check therapist name
					therapist_name = $('input[name=therapist_id]').val();
					
					$.ajax({
						type	:	"GET",
						data	:	{command: "checktherapist", therapist_name: therapist_name},
						url		:	"ajax.php",
						success	:	function(data){
							console.log(therapist_name+" | "+data);
							if(data == 1){
								if(confirm("Submit transfer?")){
									$('#transfer_therapist_form').submit();
									return false;
									//return true;
								}else{
									return false;
								}
							}else{
								alert("ข้อมูลหมอไม่ถูกต้อง กรุณาเลือกใหม่อีกครั้ง");
								return false;
							}
						}
					});
				}else{
					alert("ข้อมูลการส่งตัวหมอต้องครบถ้วนทั้ง 2 ช่อง");
					return false;
				}
				
			}else{
				alert("โปรดป้อนข้อมูลให้ครับถ้วน");
				return false;
			}
		});
		$('#all_therapist_transfer .button.delete').click(function(){
			transfer_id = $(this).attr('transfer_id');
			if(confirm("Delete this transfer?")){
				loading();
				$.ajax({
					type	:	"POST",
					data	:	{command: "delete_therapist_transfer", transfer_id: transfer_id},
					url		:	"ajax.php",
					success	:	function(data){
						unload();
						$('.transfer_therapist .dropzone2').html(data);
						setTherapistButton();
					}
				});
			}
		});
		$('#transfer_therapist_form .button.delete').click(function(){
			if(confirm("Delete this route?")){
				route_id = $(this).attr('route_id');
				employee_id = $(this).attr('employee_id');
				loading();
				$.ajax({
					type	:	"POST",
					data	:	{command: "delete_therapist_route", route_id: route_id, employee_id: employee_id},
					url		:	"ajax.php",
					success	:	function(data){
						unload();
						$('.transfer_therapist .dropzone').html(data);
						setTherapistButton();
					}
				});
			}
		});
	}
	
	function checkTherapist(){
		$('input.check_therapist').on('change keyup', function(){
			therapist = $(this).val();
			console.log(therapist);
			$.ajax({
				type	:	"GET",
				data	:	{command: "checktherapist", therapist: therapist},
				url		:	"ajax.php",
				success	:	function(data){
					//alert(data);
				}
			});
		});
	}

	// PIN
	$('button[name=submit-change-pin]').click(function(){
		card_id = $(this).attr('card_id');
		new_pin = $('input[name=pin-code]').val();
		retype_pin_code = $('input[name=retype-pin-code]').val();
		if(new_pin == retype_pin_code && new_pin != ""){
			pin_length = new_pin.replace(/ /g,'').length
			if(pin_length == 4){
				if(confirm("Submit PIN?")){
					$.ajax({
						type	:	"POST",
						url		:	"ajax.php",
						data	:	{command: "submitchangepin", card_id: card_id, new_pin: new_pin},
						success	:	function(data){
							$('.card-pin-input').parent().parent().html(data);
						}
					});				
				}
			}else{
				alert("PIN length must be 4 characters long.");
			}
		}else{
			alert("Two PIN field must be the same and not empty.");
		}
	});
	
	card_detail_scan_exist = $('#card_detail_scan').length;
	if(card_register_exist || card_transfer_form_exist || card_detail_scan_exist){
		if(card_detail_scan_exist){
			command = "loadcarddetail";
			sub_command = "detail";
		}else if(card_register_exist){
			command = "loadcard";
			sub_command = "register";
		}else if(card_transfer_form_exist){
			command = "loadcard";
			sub_command = "transfer";
		}
		$(document).click(function(event) {
		    if(!$(event.target).closest('.card_area').length) {
		        if($('.card_area').hasClass("active")) {
		            $('.card_area').removeClass('active');
		            
		            $('.card_area .press_title').html('<span class="glyphicon glyphicon-qrcode"></span> Click here to scan card');
		            scanZone();
		        }
		    }else{
			    $('.card_area').addClass("active");
			    $('.card_area .press_title').html('please scan a card');
			    $(window).scannerDetection({
					timeBeforeScanTest	:	300, // tolerate mid-scan gaps (long codes)
					onReceive		:	function(data){
					},
					onError		:	function(data){
					},
					onComplete	:	function(data){
						loading();
						$.ajax({
							url		:	"ajax.php",
							data	:	{command: command, code:data, sub_command: sub_command},
							type	:	"POST",
							dataType:	"json",
							success	:	function(data){
								unload();
								// console.log(data);
								if(data.command == "loadcarddetail"){
									if(data.status){
										$('.dropzone').html(data.show);

										// SET PIN BUTTON
										$('button[name=submit-change-pin]').click(function(){
											card_id = $(this).attr('card_id');
											reset_request_id = $('input[name=reset_request_id]').val();
											new_pin = $('input[name=pin-code]').val();
											retype_pin_code = $('input[name=retype-pin-code]').val();
											if(new_pin == retype_pin_code && new_pin != ""){
												//$('form[name=change-pin-form]').submit();
												$.ajax({
													type	:	"POST",
													url		:	"ajax.php",
													data	:	{command: "submitchangepin", card_id: card_id, new_pin: new_pin, reset_request_id: reset_request_id},
													success	:	function(data){
														$('.card-pin-input').parent().parent().html(data);
													}
												});
											}else{
												alert("Two PIN field must be the same and not empty.");
											}
										});

										$('button[name=close-change-pin]').click(function(){
											$('.popup').fadeOut(200, function(){
												$(this).remove();
											});
										});
									}
									$('.card_area').html('<div class=empty_area_for_card><div class=press_title>'+data.message+'</div></div>');
								}else{
									if((data.status == "sold" && card_register_exist) || (data.status == "create" && card_transfer_form_exist)){
										$('.card_area').html(data.show);
										$('input[name=card_code]').val(data.code);
									}else{
										if(data.status == null){
											console.log('null');
											$('.card_area').html('<div class=empty_area_for_card><div class=press_title>Incorrect code, please try again</div></div>');
											$('input[name=card_code]').val("");
										}else{
											console.log('false');
											$('.card_area').html(data.text);
											$('input[name=card_code]').val("");
										}
										
									}
								}
							}	
						});
					}
				});
		    }       
		})
	}
	
	//delivery 
	
	admin_delivery_exist = $('#admin.delivery').length;
	admin_delivery_goods_exist = $('#admin.delivery_goods').length;
	if(admin_delivery_exist || admin_delivery_goods_exist){
		setDeliveryButton();
	}
	
	
	$('button[name=submit_delivery_transfer]').click(function(){
		date = $('input[name=delivery_date]').val();
		if(requireCheck()){
			vars = $('form[name=delivery_product_form]').serializeArray();
			stock_type = $('input[name=stock_type]').val();
			
			// if(stock_type == "goods"){
			// 	$.ajax({
			// 		url		:	"ajax.php",
			// 		data	:	vars,
			// 		dataType:	"json",
			// 		type	:	"POST",
			// 		success	:	function(data){
			// 			console.log(data);
			// 		}
			// 	});
			// }


			// $.ajax({
			// 	url		:	"ajax.php",
			// 	data	:	vars,
			// 	dataType:	"json",
			// 	type	:	"POST",
			// 	success	:	function(data){
			// 		// console.log(data.product);
			// 		$('.item_status').remove();
			// 		$.each(data.product, function(index, val){
			// 			if(val.enough){
			// 				icon = "glyphicon glyphicon-ok";
			// 				color = "green";
			// 			}else{
			// 				icon = "glyphicon glyphicon-remove";
			// 				color = "red";
			// 			}
			// 			if(index != ""){
			// 				//badge แสดงจำนวนตอนเพิ่มของ delivery
			// 				$('.product_id[value='+index+']').parent().parent().append("<div class='col-md-2 col-sm-2 item_status'><span class='"+icon+" "+color+"'></span> <span class='badge "+color+"'>"+val.badge+"</span></div>");
			// 			}
			// 		});
			// 		if(data.pass){
			// 			if(confirm("ยืนยันการทำรายการส่งสินค้า?")){
			// 				$('form[name=delivery_product_form]').submit();
			// 				return true;
			// 			}else{
			// 				return false;
			// 			}
			// 		}else{
			// 			alert("สินค้าบางตัวมีจำนวนไม่พอสำหรับการส่ง");
			// 		}
			// 	}
			// });
			if(ValidateDate(date)){
				if(confirm("Confirm products delivery?")){
					$('form[name=delivery_product_form]').submit();
					return true;
				}else{
					return false;
				}
			}else{
				alert("Incorrect delivery date");
				return false;
			}
		}else{
			return false;
		}

		if(confirm("Confirm products delivery?")){
			$('form[name=delivery_product_form]').submit();
			return true;
		}else{
			return false;
		}
	});
	setButtonDeliveryProduct();
	
	$('button[name=delivery_submit]').click(function(){
		receive_date_exist = $('input[name=receive_date]').length;
		if(receive_date_exist){
			// recieve
			date = $('input[name=receive_date]').val();
			if(requireCheck()){
				if(ValidateDate(date)){
					if(confirm("Confirm?")){
						$('form[name=delivery_form]').submit();
						return true;
					}else{
						return false;
					}
				}else{
					alert("Incorrect receive date");
					return false;
				}
			}
		}else{
			// adjust
			if(confirm("Confirm?")){
				$('form[name=delivery_form]').submit();
				return true;
			}else{
				return false;
			}
		}
	});
	
	$('button.not-receive').click(function(){
		stock_id = $('input[name=stock_id]').val();
		stock_item_id = $(this).attr('stock_item_id');
		command_box = $(this).parent().parent().parent();
		status_badge = command_box.parent().parent().find('.label_text');
		if(confirm("ยืนยันใช่มั้ยว่าไม่ได้รับของจริงๆ นะ?")){
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "delivery_not_receive", stock_id: stock_id, stock_item_id: stock_item_id},
				success	:	function(data){
					command_box.remove();
					status_badge.html('not-receive').attr('class', 'label_text not-receive');
				}
			});
		}else{
			//do nothing
		}
	});
	
	
	$('button.stock_delete_item').click(function(){
		stock_item_id = $(this).attr('stock_item_id');
		if(confirm("Delete this product?")){
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "stock_delete_item", stock_item_id: stock_item_id},
				success	:	function(data){
					location.reload();
				}
			});
		}
	});
	
	
	//cashier
	// $('.float_group #filter select[name=select_branch], #filter select.select_branch').change(function(){
	// 	branch = $(this).val();
	// 	$.ajax({
	// 		type	:	"POST",
	// 		url		:	"ajax.php",
	// 		data	:	{command: "changeBranchCashier", branch:branch},
	// 		beforeSend : function(){
	// 			$('#report .dropzone').html("<div class='loading'></div>");
	// 		},
	// 		success	:	function(data){
	// 			$('.page_body').html('<div class=\'announce success\'>changing branch</div>');
	// 			window.setTimeout('location.reload()', 200);
	// 		}
	// 	});
	// });
	
	function checkableReceiptNo(){
		$('.checkable_receipt_no').unbind('keyup');
		$('.checkable_receipt_no').keyup(function(){
			receipt_no = $(this).val();
			console.log(receipt_no);
			obj = $(this);
			$.ajax({
				type	:	"GET",
				url		:	"ajax.php",
				data	:	{command: "checkreceiptno", receipt_no: receipt_no},
				success :	function(data){
					obj.parent().find('.error_message').html("");
					if(data == 0){
						//false
						obj.after('<div class="error_message red">Receipt no. not correct</div>');
					}else{
						obj.after('<div class="error_message green">Receipt no. correct</div>');
						//obj.parent().find('.error_message').remove();
					}
				}
			});
		});
	}

	// ERP
	setERPApprove();
	function setERPApprove(){
		$('.erp_submit').click(function(){
			transaction_id = $(this).attr('transaction_id');
			erp_action = $(this).attr('erp_action');
			command_box = $(this).parent();
			command_box.html("<div class='loading black'></div>");
			$.ajax({
				type		:	"POST",
				url			:	"ajax.php",
				data		:	{command: "erp_submit", transaction_id: transaction_id, erp_action: erp_action},
				dataType	:	"json",
				beforeSend	:	function(){
					
				},
				success		:	function(data){
					setTimeout(function(){
						// console.log(data);
						command_box.html("<div class='press_title gold'>"+data.erp_action+"</div>");
						window.setTimeout('location.reload()', 1000);
					}, 500);
				}
			});
		});
	}
	
	//void	
	setVoidPage();
	function setVoidPage(){
		void_exist = $('#void_page').length;
		if(void_exist != 0){
			$('#void_form button[name=void_submit_button]').click(function(){
				count = 0;
				$('#void_form input[type=radio]').each(function(){
					if($(this).is(':checked')){
						count++;
						val = $(this).parent().parent().parent().find('select.void_reason').val();
						val_note = $(this).parent().parent().parent().find('.void_note.require').val();
						val_receipt = $(this).parent().parent().parent().find('.checkable_receipt_no').val();
						if(val == '' || val_note == '' || val_receipt == ''){
							alert('Please make sure all required fields are filled out correctly');
						}else{
							//check receipt no
							if(val_receipt != undefined){
								$.ajax({
									type	:	"GET",
									url		:	"ajax.php",
									data	:	{command: "checkreceiptno", receipt_no: val_receipt},
									success :	function(data){
										if(data == 0){
											alert("Receipt no. not correct");
										}else{
											if(confirm('Do you really want to void the receipts?')){
												$('#void_form').submit();
											}
										}
									}
								});
							}else{
								if(confirm('Do you really want to void the receipts?')){
									$('#void_form').submit();
								}
							}
						}
					}
				});
				return false;
			});
			
			$('#void_form .void_reason').change(function(){
				reason_id = $(this).val();
				print_id = $(this).attr('print_id');
				parent = $(this).parent().parent().parent();
				
				is_product = $(this).hasClass("product");
				is_admin = $(this).hasClass("admin");
				
				require_receipt_no = $(this).find('option:selected').attr('require_receipt_no');
				require_receipt_no_product = $(this).find('option:selected').attr('require_receipt_no_product');
				
				use_receipt = false;
				if(is_admin == 1){
					if(is_product == 1){
						if(require_receipt_no_product == 1){
							use_receipt = true;
						}
					}else{
						if(require_receipt_no == 1){
							use_receipt = true;
						}
					}
				}else{
					if(require_receipt_no_product == 1){
						use_receipt = true;
					}
				}
				console.log("use receipt : "+use_receipt+" | is_admin : "+is_admin+" | require_receipt_no : "+require_receipt_no+" | require_receipt_no_product : "+require_receipt_no_product);
		
				//alert(reason_id+" | "+print_id+" require_receipt_no : "+require_receipt_no);
				parent.find('.receipt_box').remove();
				if(use_receipt == 1){
					parent.append("<div class='receipt_box row' style='margin-top:10px;'><label class='control-label col-md-4'>new receipt no.</label><div class='col-md-8'><input type='text' name='new_receipt_no["+print_id+"]' class='form-control input-sm require checkable_receipt_no'></div></div>");
					checkableReceiptNo();
				}
			});
			checkableReceiptNo();
		}
	}
	
	$('#void #filter .date').click(function(){
		if($(this).hasClass('today')){
			dateType = "today";
		}else{
			dateType = "yesterday";
		}
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "changeDayVoid", dateType: dateType},
			beforeSend : function(){
				loading();
				$('.dropzone').html("<div class='loading black'></div>");
			},
			success	:	function(data){
				unload();
				$('.dropzone').html(data);
				setVoidPage();
			}
		});
	});
	
	//guide
	$('#add_guide_form, .form_require').submit(function(){
		pass = requireCheck();
		return pass;
	});
	
	//delivery
	$('#filter.delivery_filter select.select_delivery, #filter.delivery_filter input.date_input, #filter.delivery_goods_filter select.select_delivery, #filter.delivery_goods_filter input.date_input').change(function(){
		delivery_status_id = $(this).val();
		vars = $('#filter_form').serializeArray();
		command = $('input[name=command]').val();
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data 	:	vars,
			beforeSend : function(){
				loading();
			},
			success	:	function(data){
				unload();
				$('.dropzone').html(data);
				//set delivery button
				setDeliveryButton();
			}
		});
	});
	
	//stock
	$('#stock input[name=stock_code]').bind('change keyup', function(){
		loading();
		date_receive = $('input[name=date_receive]').val();
		stock_code = $('input[name=stock_code]').val();
		receiver_name = $('input[name=receiver_name]').val();
		//console.log(date_receive+" | "+stock_code+" | "+receiver_name);
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "getstock", stock_code: stock_code},
			dataType:	"json",
			success	:	function(data){
				unload();
				$('.amount').val(""); //clear
				//console.log(data);
				if(data.exist > 0){
					total = data.product.length;
					for(i = 0; i <= total; i++){
						//console.log(typeof(data[i]));
						if(typeof(data.product[i]) != 'undefined'){
							$('.amount'+data.product[i].product_id).val(data.product[i].amount);
						}
					}
				}
			}
		});
	});
	
	//stock summary
	$('#stock_upload_form button[name=submit_upload]').click(function(){
		pass = requireCheck();
		if(pass){
			file = $('input[name=csv_file]').val();
			pass2 = checkFileExtension(file, "csv");
			if(pass2){
				if(confirm("Proceed to next step?")){
					$('#stock_upload_form').submit();
				}
			}
		}
	});

	$('.fulltax_void_button').click(function(){
		full_tax_id = $(this).attr('full_tax_id');
		void_note = prompt("โปรดระบุเหตุผลที่ทำการ void");
		if(void_note === null){
			// alert('null');
		}else if(void_note != ""){
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "void_fulltax", full_tax_id: full_tax_id, void_note: void_note},
				success	:	function(){
					$(document).ajaxStop(function(){
					    window.location.reload();
					});
				}
			});
		}else{
			alert("โปรดระบุเหตุผลด้วย");
		}
	});

	// CHECK ALL
	$('button.check_all').click(function(){
		$(this).parent().parent().find('input[type=checkbox]').prop('checked', true);
	});
	$('button.uncheck_all').click(function(){
		$(this).parent().parent().find('input[type=checkbox]').prop('checked', false);
	});
	
	$('button.submit_full_tax').click(function(){
		//check receipt no
		receipt_no = $('input[name=receipt_no]').val();
		$.ajax({
			type		:	"GET",
			url			:	"ajax.php",
			dataType	:	"json",
			data		:	{command: "checkreceiptnoFullTAX", receipt_no: receipt_no},
			success		:	function(data){
				if(data.show != "pass"){
					//false
					alert(data.message);
					final_pass = false;
				}else{
					//pass
					pass = requireCheck();
					member_type_box_exist = $('.member_type_box').length;
					customer_branch_number = $('input[name=customer_branch]').val().length;
					customer_branch_exist = $('input[name=customer_branch]').length;
					if(pass && member_type_box_exist){
						//check tax_no length
						tax_no = $('input[name=tax_no]').val().length;
						if(tax_no != 13){
							alert("เลขประจำตัวผู้เสียภาษีต้องมีความยาว 13 หลักเท่านั้น");
							pass = false;
						}else{
							if(customer_branch_exist){
								if(customer_branch_number != 5){
									alert("branch number ต้องไม่เป็นค่าว่างและต้องมีความยาว 5 ตัวเลขเท่านั้น");
									pass = false;
								}else{
									pass = true;
								}
							}else{
								pass = true;
							}
						}
					}else{
						pass = false;
						alert("No customer information");
						final_pass = false;
					}
					if(pass){
						if(confirm("All informations are correct?")){
							final_pass = true;
						}else{
							final_pass = false;
						}
					}
				}
				if(final_pass){
					$('#full_tax_form').submit();
				}
			}
		});
		return false;
	});

	$('button.update_full_tax').click(function(){
		pass = requireCheck();
		customer_branch_number = $('input[name=customer_branch]').val().length;
		customer_branch_exist = $('input[name=customer_branch]').length;
		if(pass){
			if(customer_branch_exist){
				if(customer_branch_number != 5){
					alert("TAX Branch ต้องไม่เป็นค่าว่างและต้องมีความยาว 5 ตัวเลขเท่านั้น");
					return false;
				}else{
					if(confirm("All informations are correct?")){
						return true;
					}else{
						return false;
					}
				}
			}else{
				if(confirm("All informations are correct?")){
					return true;
				}else{
					return false;
				}
			}
		}else{
			return false;
		}
	});

	// VAT REFUND
	vat_refund_exist = $('.vat_refund.description').length;
	if(vat_refund_exist){
		$(window).scannerDetection({
			timeBeforeScanTest	:	300, // tolerate mid-scan gaps (long codes)
			onComplete	:	function(code){
				if($.isNumeric(code)){
					// NUMBER
					serial_no_length = 8;
				    var length = code.length;

				    var serial_no = code.substring(length - serial_no_length);
				    var vol_no = code.substring(0, length - serial_no_length);

					$('input[name=vol_no]').val(vol_no);
					$('input[name=serial_no]').val(serial_no);
				}else{
					alert("เปลี่ยนภาษาก่อนนะ");
				}
			}
		});
	}
	
	$('#vat-refund-print, #vat-refund-view').click(function(){
		if(requireCheck()){
			loading();
			receipt_no = $('input[name=receipt_no]').val();
			vol_no = $('input[name=vol_no]').val();
			serial_no = $('input[name=serial_no]').val();

			button = $(this).attr('id');

			if(vol_no !== undefined && serial_no !== undefined){
				// INSERT TO DATABASE
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "vat_refund_log", receipt_no: receipt_no, vol_no: vol_no, serial_no: serial_no},
					success	:	function(data){
						unload();
						$('.vat_refund.description .announce').remove();
						$('.vat_refund.description .press_title').after(data);
						$('.vat_refund.description .announce').hide().fadeIn(200);

						// FOR DISPLAY
						if(button == "vat-refund-view"){
							$.ajax({
								type	:	"POST",
								url		:	"ajax.php",
								data	:	{command: "vat_refund", receipt_no: receipt_no},
								success	:	function(data){
									$('.dropzone').html(data);
									unload();
								}
							});
						}

						// FOR PRINT
						if(button == "vat-refund-print"){
							return true;
						}
					}
				});
			}else{
				// FOR DISPLAY
				if(button == "vat-refund-view"){
					$.ajax({
						type	:	"POST",
						url		:	"ajax.php",
						data	:	{command: "vat_refund", receipt_no: receipt_no},
						success	:	function(data){
							$('.dropzone').html(data);
							unload();
						}
					});
				}
			}
		}else{
			// PLEASE INPUT ALL THE REQUIRE FIELDS
			return false;
		}
	});

	$('button[name=submit_contract]').click(function(){
		pass = requireCheck();
		customer_branch_number = $('input[name=city_branch]').val().length;
		customer_branch_exist = $('input[name=city_branch]').length;
		if(pass){
			if(customer_branch_exist){
				if(customer_branch_number != 5){
					alert("branch number ต้องไม่เป็นค่าว่างและต้องมีความยาว 5 ตัวเลขเท่านั้น");
					return false;
				}else{
					if(confirm("All informations are correct?")){
						return true;
					}else{
						return false;
					}
				}
			}else{
				if(confirm("All informations are correct?")){
					return true;
				}else{
					return false;
				}
			}
		}else{
			return false;
		}
	});

	//guide form
	guide_form_exist = $('#add_guide_form').length;
	if(guide_form_exist){
		if($('select[name=pay_method]').val() == "cash"){
			$('.bank_input').hide();
		}
		$('select[name=pay_method]').change(function(){
			pay_method = $(this).val();
			if(pay_method == "bank"){
				$('.bank_input').show();
			}else{
				$('.bank_input').hide();
			}
		});
	}
	//report
	$('.column-close').click(function(){
		column = $(this).attr('column');
		$('th.'+column+', td.'+column).hide();
	});
	$('.column-hilight').click(function(){
		color_class = $(this).attr('data-color-class');
		column = $(this).attr('column');
		$('th.'+column+', td.'+column).removeClass('bg_light_red bg_light_green bg_light_blue bg_light_yellow').addClass(color_class);
	});
	$('#filter input[name=start_date], #filter input[name=end_date]').change(function(){
		start_date = Date.parse($('#filter input[name=start_date]').val());
		end_date = Date.parse($('#filter input[name=end_date]').val());
		if(end_date < start_date){
			end_date = start_date;
		}
		use_start_date = $.datepicker.formatDate('yy-mm-dd', start_date);
		use_end_date = $.datepicker.formatDate('yy-mm-dd', end_date);
		$('#filter input[name=start_date]').val(use_start_date);
		$('#filter input[name=end_date]').val(use_end_date);
	});
	
	$('#report #filter select:not(.select_branch, .select_brand), #report #filter input[type!=checkbox]').change(function(){//, input[name=show_foc], input[name=show_void], filter[type]
		get_s = getURLParameter("s");
		if(get_s == "sale_summary"){
			name = $(this).attr('name');
			$('.filter_group').removeClass('active');
			if(name == "filter[year]" || name == "filter[quarter]"){
				$('.special_value').val('quarter');
				$(this).parent().parent().parent().addClass('active');
			}else{
				$('.special_value').val('date');
				$('select.select_quarter').val('');
				$(this).parent().parent().parent().addClass('active');
			}
		}
		// QUERY ON GO BUTTON (#filter_form submit)
	});

	// REPORT FILTER : GO BUTTON
	$('#report #filter .select_branch, #report #filter .select_brand').each(function(){
		$(this).data('initial', $(this).val());
	});
	// REPORT REQUEST STATE : CLICK GO AGAIN WHILE LOADING -> ABORT + KILL OLD DB QUERY (report_cancel.php) BEFORE NEW ONE
	var report_xhr = null;
	var report_running = false;
	var report_seq = 0;
	// RANDOM PER PAGE LOAD : report_cancel.php ONLY KILLS THIS TAB'S REPORT
	var report_tab = (Math.random().toString(36).slice(2) + Date.now().toString(36)).replace(/[^a-z0-9]/g, '').slice(0, 40);
	function runReportFilter(){
		// ROLE limit_view_report_days : QUICK DATE BUTTONS SKIP datepicker minDate, PULL DATES BACK (SERVER CHECKS TOO)
		var limit_days = parseInt($('#filter_form input[name=limit_view_report_days]').val(), 10);
		if(limit_days > 0){
			var min_date = new Date();
			min_date.setDate(min_date.getDate() - limit_days);
			var min_str = $.datepicker.formatDate('yy-mm-dd', min_date);
			$('#filter_form .start_date_input, #filter_form .end_date_input').each(function(){
				if($(this).val() && $(this).val() < min_str){
					$(this).val(min_str);
				}
			});
			var $compare = $('#filter_form .compare_start_date_input, #filter_form .compare_end_date_input');
			$compare.each(function(){
				if($(this).val() && $(this).val() < min_str){
					$compare.val('');
					return false;
				}
			});
		}
		vars = $('#filter_form').serializeArray();
		vars.push({name: 'report_tab', value: report_tab});

		// BRAND / BRANCH CHANGE : SET SESSION FIRST (brand before branch, changeBrand resets branch to all)
		var session_calls = [];
		var $brand = $('#report #filter .select_brand');
		var $branch = $('#report #filter .select_branch');
		if($brand.length && $brand.val() != $brand.data('initial')){
			session_calls.push({command: "changeBrand", brand: $brand.val()});
		}
		if($branch.length && $branch.val() != $branch.data('initial')){
			session_calls.push({command: "changeBranch", branch: $branch.val()});
		}

		var seq = ++report_seq;
		var was_running = report_running;
		if(report_xhr){
			report_xhr.abort();
			report_xhr = null;
		}
		report_running = true;
		unload();
		loading();

		var finish = function(){
			if(seq != report_seq){
				return;
			}
			report_running = false;
			report_xhr = null;
			unload();
		};
		var postReport = function(){
			report_xhr = $.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	vars,
				success	:	function(data){
					if(seq != report_seq){
						// OLD REQUEST
						return;
					}
					console.log("filter --- report");
					// ajax.php SENDS application/json WHEN OUTPUT IS VALID JSON, SO "1" ARRIVES AS NUMBER 1
					if(data == true || session_calls.length){
						// FOR REDIRECT ONLY / BRAND OR BRANCH CHANGED
						report_running = false;
						location.reload();
						return;
					}
					finish();
					// SOME COMMANDS RETURN JSON {show} / {message}
					if(data && typeof data === 'object'){
						data = data.message ? data.message : data.show;
					}
					$('.dropzone').html(data);

					setSaleReportApprove();

					// SET BUTTON
					setPayrollButton();

					// SET SORT
					$(".tablesorter").tablesorter();
				},
				error	:	function(xhr, status){
					if(status != 'abort'){
						finish();
					}
				}
			});
		};
		var postSession = function(i){
			if(seq != report_seq){
				return;
			}
			if(i >= session_calls.length){
				postReport();
				return;
			}
			report_xhr = $.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	session_calls[i],
				success	:	function(){
					postSession(i + 1);
				},
				error	:	function(xhr, status){
					if(status != 'abort'){
						finish();
					}
				}
			});
		};

		if(was_running){
			// KILL OLD QUERY FIRST, OTHERWISE THE NEW REQUEST WAITS ON THE SESSION LOCK UNTIL THE OLD ONE ENDS
			$.ajax({
				type		:	"POST",
				url			:	"report_cancel.php",
				data		:	{report_tab: report_tab},
				complete	:	function(){
					postSession(0);
				}
			});
		}else{
			postSession(0);
		}
	}
	$(window).on('beforeunload', function(){
		// LEAVE / RELOAD WHILE LOADING : KILL THE QUERY TOO
		if(report_running && navigator.sendBeacon && window.FormData){
			var fd = new FormData();
			fd.append('report_tab', report_tab);
			navigator.sendBeacon('report_cancel.php', fd);
		}
	});
	$('#report #filter_form').on('submit', function(e){
		e.preventDefault();
		runReportFilter();
	});
	
	$('.inout-filter button').click(function(){
		$('.inout-filter button').removeClass('active');
		$(this).addClass('active');
		button_val = $(this).val();
		$('.delivery_filter').val(button_val);
		vars = $('#filter_form').serializeArray();
		//console.log(vars);		
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	vars,
			beforeSend : function(){
				loading();
			},
			success	:	function(data){
				unload();
				$('.dropzone').html(data);
			}
		});
	});
	
	//------------------------------------//
	$('.select_branch').not('#report #filter .select_branch').unbind('change').change(function(){ // #filter.therapist.admin_filter | #report : QUERY ON GO BUTTON
		// loading();
		branch_id = $(this).val();
		$('.page_body').html('<div class=\'announce success\'>Changing Branch</div>');
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "changeBranch", branch: branch_id},
			success	:	function(data){
				// unload();
				location.reload();
			}
		});
	});
	
	$('#filter input.date_input, #filter select.select_order_type').not('#report #filter *').change(function(){ // #report : QUERY ON GO BUTTON
		vars = $('#filter_form').serializeArray();
		command = $('input[name=command]').val();
		// console.log(vars);
		console.log("----- filter | script.js command "+command+" -----");
		
		if($(this).hasClass('special_date')){
			// SKIP EVERYTHING
			return false;
		}else{
			$.ajax({
				type		:	"POST",
				url			:	"ajax.php",
				dataType	:	"json",
				data		:	vars,
				beforeSend	:	function(){
					loading();
				},
				success		:	function(data){
					unload();
					if(data == true){
						window.location.reload();
					}else{
						if(data.message){
							// I DONT KNOW WHAT TO DO
							$('.dropzone').html(data.message);
						}else{
							$('.dropzone').html(data.show);
							$('.booking-date-button').prop('disabled', false);
							
							$(".tablesorter").tablesorter();
							if(command == "command_void"){
								setVoidPage(); //setting
							}else if(command == "admin_erp_approve"){
								setERPApprove();
							}else if(command == "admin_time"){
								setBlockTimeButton();
								setTherapistCheckInButton();
								setHoverTimeBlock();
								setDeleteTimeButton();
							}
							setPayrollButton();
						}
					}
				}
			});
		}
	});
	//------------------------------------//
	
	// #report #filter .cool_switch / .void_checkbox / .filter_input : QUERY ON GO BUTTON (runReportFilter)

	/* default queue */
	function setDeleteDefaultButton(){
		$('button.delete_default_queue').click(function(){
			date = $(this).val();		
			if(confirm("delete?")){
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "delete_default_queue", date: date},
					success	:	function(data){
						$('.queue_default .right').html(data);
						setDeleteDefaultButton();
					}
				});
				return false;
			}else{
				return false; 
			}
		});
	}
	setDeleteDefaultButton();
	
	/* queue */
	current_queue = $('.queue_input').length;
	{
		$('.queue .move_to_bottom').click(function(){
			// if(confirm("ย้ายหมอคนนี้ไปท้ายคิวมั้ย?")){
				queue_content = $('.queue .content');
				$(this).parent().parent().appendTo(queue_content);
			// }
		});
		$('.queue .move_to_top').click(function(){
			// if(confirm("ย้ายหมอคนนี้ไปต้นคิวมั้ย?")){
				queue_content = $('.queue .content');
				$(this).parent().parent().prependTo(queue_content);
			// }
		});
		$('.queue .delete_queue').click(function(){
			if(confirm("Delete this therapist queue?")){
				$(this).parent().parent().remove();
			}
		});
	}
	
	function reQueue(){
		i = 1;
		$('.queue_input').each(function(){
			$(this).find('.index_number').html(i);
			i++;
		});
	}
	function addQueueTherapis(dragable){
		if(sortable == "sortable"){
			sortable = "<div class='col-md-3 drag_button'><span class='glyphicon glyphicon-move'></span> drag</div>";
		}else{
			sortable = "";
		}
		input = "<div class='form-group queue_input queue_input"+(current_queue + 1)+" clearfix'><div class='col-md-1'><span class='glyphicon glyphicon-plus user_icon_status green'></span></div><label class='index_number control-label col-md-1 label'>"+(current_queue + 1)+"</label><div class='col-md-5'><div class='input drag clearfix'><input type='text' name='code["+current_queue+"]' value='' class='input-sm form-control auto_employee local app_input cool_input code_input uc"+current_queue+"'></div><input type='hidden' name='status["+current_queue+"]' value='active'></div><div class='col-md-2'><button type='button' class='btn btn-danger remove_but justadd button cross btn-xs'><span class='glyphicon glyphicon-remove'></span> remove</button></div>"+sortable+"</div>";
		$('.dropzone .queue_list').append(input);
		$('.auto_employee').autocomplete({
			source: path+"ajax_autocomplete.php?type=all",
			minLength: 1,
			autoFocus: true,
			close:	function(){
			}
		});
		$('.queue_input'+(current_queue + 1)+' button.remove_but').click(function(){
			parent = $(this).parent().parent();
			parent.fadeOut(200, function(){
				$(this).remove();
				reQueue();
			});
		});
		current_queue++;
		reQueue();
	}
	$('.queue .add_therapist_button, .queue_default .add_therapist_button').click(function(){
		sortable = $(this).attr('sortable');
		addQueueTherapis(sortable);
	});
	$('.queue #filter_form input.date_input, .queue_default #filter_form input.date_input').change(function(){
		vars = $('#filter_form').serializeArray();
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	vars,
			beforeSend : function(){
				loading();
				$('.dropzone').html("<div class='loading'></div>");
			},
			success	:	function(data){
				unload();
				$('.dropzone').html(data);
				current_queue = $('.queue_input').length;
				$('.queue .add_therapist_button, .queue_default .add_therapist_button').click(function(){
					addQueueTherapis();
				});
				$('.auto_employee').autocomplete({
					source: path+"ajax_autocomplete.php?type=all",
					minLength: 1,
					autoFocus: true,
					close:	function(){
					}
				});
				$('.queue button.remove_but, .queue_default button.remove_but').click(function(){
					parent = $(this).parent().parent();
					parent.fadeOut(200, function(){
						$(this).remove();
						reQueue();
					});
				});
				$('.sortable').sortable({
					placeholder	: "ui-state-highlight",
					stop		:	function(){
						// reQueue();
					}
				});
				
			}
		});
	});
	$('.queue button.remove_but, .queue_default button.remove_but').click(function(){
		parent = $(this).parent().parent();
		parent.fadeOut(200, function(){
			$(this).remove();
			reQueue();
		});
	});
	
	//------------------------------------------------------------------------------------------------------------------------
	
	//sort button
	var object_array = new Array();
	function sortMePlease(order){
		//if(typeof object_array[0] == 'undefined'){
			$('.item_group').each(function(){
				//num = parseInt($(this).attr('num')) - 1;
				//object_array[num] = $(this);
				object_array.push($(this));
			});
			console.log(object_array);
			console.log("-----------------");
			console.log(order);
			$('.dropzone').fadeOut(200, function(){
				$(this).html('');
				order.forEach(function(val){
					$('.dropzone').append(object_array[val]);
				});
				$(this).fadeIn(200);
			});
		//}
	}
	
	
	/* wizard */
	$('#new_cashier_form button.wizard').click(function(){
		getSaleAutoTherapist();
	});

	$('#new_cashier_form select[name=treatment_hour], #new_cashier_form select[name=treatment_minute]').change(function(){
		$item_count = $('.dropzone .item_group').length;
		wizard_box_exist = $('.wizardzone .wizard_box').length;
		if($item_count > 0 && wizard_box_exist > 0){
			getSaleAutoTherapist();
		}
	});

	function getSaleAutoTherapist(){
		console.log('Wizard');
		loading();
		total_item = $('.item_group').length;
		if(total_item > 0){
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "clearSkipAll"},
				success	:	function(data){
					unload();
					// console.log(data);
					getSkipBox();
					$('.dropzone').fadeTo(200, 0.2).addClass('disable');
					$('.wizardzone').html('').fadeIn(200).addClass('loading black');
					wizardSuccess();
				}
			});
		}
	}

	getCashierMemberLogin();

	function getMemberInventoryLoginCashier(){
		// CHANGE STATUS
		$('#customer_email_telephone').keyup(function(){
			// CHECK CUSTOMER INPUT FIELD
			checkMemberExist($(this).val());

			if($(this).val() == ''){
				$('#loginStatus').val(true);
			}else{
				$('#loginStatus').val('');
			}
		});

		// AUTO-CHECK ON BLUR (Sale & Quick Book pages)
		$('#customer_telephone, #customer_email').on('blur', function(){
			var val = $.trim($(this).val());
			if(val.length >= 6){
				$('#check-info-button').trigger('click');
			}else{
				handleBannedMember(null, '.status');
			}
		});

		// LOGIN BUTTON
		$('#inventory-login .submit-login').click(function(){
			// CLEAR MESSAGE
			$('#inventory-login .status').html('<i class="fas fa-spinner fa-spin fa-2x"></i>');

			// LOGIN SCRIPT
			member_email_telephone =  $('#customer_email_telephone').val();
			member_password =  $('#customer_password').val();
			loading();
			$.ajax({
				type	:	"POST",
				data	:	{command: "memberLoginByEmailTelephone", member_email_telephone: member_email_telephone, member_password: member_password},
				dataType:	"json",
				url		:	"ajax.php",
				success	:	function(data){
					if(data.pass){
						$('#customer_password').removeClass('notpass').addClass('pass');
						$('#inventory-login .status').html('<span class="press_title gold">Login Success</span>');
						$('#loginStatus').val(data.pass);

						// AUTO-FILL
						$('#customer_firstname').val(data.firstname);
						$('#customer_lastname').val(data.lastname);
					}else{
						$('#customer_password').removeClass('pass').addClass('notpass');
						$('#inventory-login .status').html('<span class="press_title red">Wrong Password</span>');
						$('#loginStatus').val('');
					}
					unload();
				}
			});
			
			// CLEAR
			if($('#customer_email_telephone').val() == ''){
				$('#loginStatus').val(true);
			}
		});
	}

	// CHANGE PASSWORD
	$('button[name=submit_change_password]').click(function(){
		old_password = $('input[name=old_password]').val();
		new_password = $('input[name=new_password]').val();
		repeat_password = $('input[name=repeat_password]').val();
		if(old_password == ""){
			$('#change_password .announce').removeClass('success').addClass('error').html("Please input the current password");
		}else if(new_password != repeat_password){
			$('#change_password .announce').removeClass('success').addClass('error').html("Passwords not match");
		}else{
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "checkPassword", password: new_password},
				success	:	function(data){
					if(data){
						if(confirm("Change password?")){
							$('#change_password_form').submit();
						}else{
							$('#change_password .announce').removeClass('error').addClass('success box').html("Pass");
						}
					}else{
						$('#change_password .announce').removeClass('success').addClass('error box').html("<div class='press_title'>Password must meet complexity requirement</div>");
					}
				}
			})
		}
	});
	
	
	//new cashier
	$('#refcode_box .ref_button').click(function(){
		if($(this).hasClass('select')){
			$('#refcode_box .ref_button').removeClass('select');
			$('input[name=ref_code]').val('');
		}else{
			$('#refcode_box .ref_button').removeClass('select');
			$(this).addClass('select');
			ref_code = $(this).attr('ref_code');
			$('input[name=ref_code]').val(ref_code);
		}
	});
	
	
/*
	$('#auto_therapist_wizard button.submit').click(function(){
		$('.dropzone').fadeTo(200, 0.2).addClass('disable');
		$('.wizardzone').html('').fadeIn(200).addClass('loading black');
		vars = $('#cashier_form').serialize();
		$.ajax({
			type		:	"POST",
			data		:	vars,
			dataType	:	"json",
			url			:	"ajax.php?command=wizard",
			error		:	function(data){
				console.log(data);
			},
			success		:	function(data){
				//$('#first').html(data);
				console.log(data);
				$('.wizardzone').html(data.show).fadeIn(200).removeClass('loading black');
				$('.button_no_wizard').click(function(){
					clearWizard();
				});
			}
		});
		
		$('#auto_therapist_wizard').modal('hide');
	});
*/
	//------------------------------------------------------------------------------------------------------------------------
	
	
	/* live calculate */
	setLiveCal();

	//use on product page
	$('#cashier_form button[name=submit_button].submit').click(function(){
		checkOnProductPageSubmit();
	});
	
	$('#cashier_form button.button_service').click(function(){
		if(confirm(confirm_change_page)){
			$('input[name=page]').val('service');
			current_product = 1;
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "getSpaMenu"},
				beforeSend : function(){
					$('.main_content').html("<div class='loading'></div>");
				},
				success	:	function(data){
					$('.main_content').html(data);
					$('#charge_box').show();
					setButtonPackage();
					setButtonTreatment();
					realtimeCalculation();
					setButtonSpecial();
					$('.date_input').datepicker({
						dateFormat:'yy-mm-dd',
						changeMonth: true,
						changeYear: true
					});
					today = Date.today();
					treatment_date = $.datepicker.formatDate('yy-mm-dd', today);
					$('input[name=treatment_date]').val(treatment_date);
				}
			});
		}
	});
	$('#cashier_form button.button_product').click(function(){
		if(confirm(confirm_change_page)){
			$('input[name=page]').val('product');
			current_product = 1;
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "getProductMenu"},
				beforeSend	:	function(){
					$('.main_content').html("<div class='loading'></div>");
				},
				success	:	function(data){
					$('.main_content').html(data);
					$('#charge_box').hide();
					setButtonProduct();
					setButtonCourse();
					setButtonSpecial();
					setNoTierProductButton()
					realtimeCalculation();
				}
			});
		}
	});
		
	//------------------------------------------------------------------------------//
	full_tax_page_exist = $('#full_tax_page').length;
	if(full_tax_page_exist){
		branch_id = $('.select_branch').val();
		$('.select_branch').unbind('change');
		$('.select_branch').change(function(){
			branch_id = $(this).val();
			//$('.auto_receipt, input[name=print_no]').val("");
			$('.auto_receipt').autocomplete({
				source: path+"ajax_autocomplete.php?type=receipt_full_tax&branch_id="+branch_id,
				minLength: 1,
				autoFocus: true,
				change:	function(event, ui){
				},
				select: function(event, ui){
					//$('input[name=print_no]').val(ui.item.print_id);
				}
			})
		});
		
		$('.auto_receipt').autocomplete({
			source: path+"ajax_autocomplete.php?type=receipt_full_tax&branch_id="+branch_id,
			minLength: 1,
			autoFocus: true,
			change:	function(event, ui){
			},
			select: function(event, ui){
				console.log(ui);
				//$('input[name=print_no]').val(ui.item.print_id);
			}
		})

		//full tax
		$('.receipt_no_for_full_tax').on('change keyup', function(){
			receipt_no = $(this).val();
			$.ajax({
				type		:	"GET",
				url			:	"ajax.php",
				dataType	:	"json",
				data		:	{command: "checkreceiptnoFullTAX", receipt_no: receipt_no},
				beforeSend	:	function(){
					$('.receipt_no_status').html('<i class="mt-2 white fas fa-spinner fa-spin fa-xs""></i>');
				},
				success		:	function(data){
					$('.receipt_no_status').html(data.message);
				}
			});
		});

		$('.member_type').change(function(){
			member_type = $(this).val();
			$('.member_info_drop_zone').html("");
			switch(member_type){
				case "city":
					$('.member_type_drop_zone').html("<label class='control-label'>search</label><input type='text' class='auto_city form-control input-sm' placeholder='search here'>");
					$('.auto_city').autocomplete({
						//member_info_drop_zone
						source: path+"ajax_autocomplete.php?type="+member_type,
						minLength: 1,
						autoFocus: true,
						select: function(event, ui){
							city_id = ui.item.city_id;
							$.ajax({
								type	:	"post",
								url		:	"ajax.php",
								data	:	{command: "getcustomerinformation", member_type: member_type, id: city_id},
								success	:	function(data){
									$('.member_info_drop_zone').html(data);
								}
							});
						}
					});
					break;
				case "member":
					$('.member_type_drop_zone').html("<label class='control-label'>search</label><input type='text' class='auto_member form-control input-sm' placeholder='search here'>");
					$('.auto_member').autocomplete({
						source: path+"ajax_autocomplete.php?type="+member_type,
						minLength: 1,
						autoFocus: true,
						select: function(event, ui){
							member_id = ui.item.member_id;
							$.ajax({
								type	:	"post",
								url		:	"ajax.php",
								data	:	{command: "getcustomerinformation", member_type: member_type, id: member_id},
								success	:	function(data){
									$('.member_info_drop_zone').html(data);
								}
							});
						}
					});
					break;
				case "guest":
					$.ajax({
						type	:	"post",
						url		:	"ajax.php",
						data	:	{command: "getcustomerinformation", member_type: member_type},
						success	:	function(data){
							$('.member_type_drop_zone').html("");
							$('.member_info_drop_zone').html(data);
						}
					});
					break;
				default:
					$('.member_type_box').remove();
					break;
			}
		});
	}
	
	
	autoEmployee();
	
	$('.auto_member').autocomplete({
		source: path+"ajax_autocomplete.php?type=member",
		minLength: 1,
		autoFocus: true,
		change:	function(event, ui){
		},
		select: function(event, ui){
			member_id = ui.item.member_id;
			$('#exist_member_form input[name=member_id]').val(member_id);
		}
	});

	autoUser();
	$('.auto_therapist').mousedown(function(){
		old_val = $(this).val();
		$(this).val('');
		$(this).mouseout(function(){
			if($(this).val() == ''){
				$(this).val(old_val);
			}
		});
	});
	autoTherapist();

	$('.super_auto_therapist').autocomplete({
		source: path+"ajax_autocomplete.php?type=super_all",
		minLength: 1,
		autoFocus: true,
		close:	function(){
			vars = $('#filter_form').serializeArray();
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	vars,
				beforeSend : function(){
					$('#report .dropzone').html("<div class='loading'></div>");
				},
				success	:	function(data){
					$('#report .dropzone').html(data);
				}
			});
		}
	});
	
	autoTherapist();
	
	$('.auto_guide').autocomplete({
		source: path+"ajax_autocomplete.php?type=guide",
		minLength: 1,
		autoFocus: true,
		close:	function(data){
			is_guide_commission_report = $('#report.guide_commission').length;
			if(is_guide_commission_report){
				// vars = $('#filter_form').serializeArray();
				console.log('auto_guide #filter_form serializeArray');
				// console.log(vars);

				// window.location.reload();
			}
		}
	});

	$('.auto_branch').autocomplete({
		source: path+"ajax_autocomplete.php?type=branch",
		minLength: 1,
		autoFocus: true,
		close:	function(){
		},
		change: function(){
		},
		select: function( event, ui ) {
			$( ".auto_branch" ).val( ui.item.label );
			$( "input[name=branch_id]" ).val( ui.item.value );
			return false;
		}
	});

	$('.auto_branch_change_branch').autocomplete({
		source: path+"ajax_autocomplete.php?type=branch",
		minLength: 1,
		autoFocus: true,
		close:	function(){
		},
		change: function(){
		},
		focus: function( event, ui ) {
			// KEEP WHAT THE USER TYPED : autoFocus FIRES THIS ON EVERY RESPONSE
			return false;
		},
		select: function( event, ui ) {
			// SHOW "id : name" AND SET THE REAL SELECT (#report : QUERY ON GO BUTTON, OTHER PAGE : changeBranch)
			$(this).val(ui.item.label);
			$(this).closest('#filter, form').find('select.select_branch')
				.val(ui.item.value)
				.trigger('change');
			return false;
		}
	});
	
	setPaymentType();

	// #cashier_form (PRODUCT PAGE)
	$('#cashier_form .discount_percent_input, #cashier_form .discount_amount_input').change(function(){
		if($('.discount_percent_input').val() == '' && $('.discount_amount_input').val() == ''){
			$('.discount_percent_input, .discount_amount_input, .main_content .sub_discount').prop('disabled', false);
		}else{
			if($(this).is('.discount_percent_input')){
				$('.discount_percent_input').prop('disabled', false);
				$('.discount_amount_input, .main_content .sub_discount').prop('disabled', true);
			}else if($(this).is('.discount_amount_input')){
				$('.discount_amount_input').prop('disabled', false);
				$('.discount_percent_input, .main_content .sub_discount').prop('disabled', true);
			}
		}
		realtimeCalculation();
	});
	
	setButtonTreatment();
	setButtonPackage();
	setButtonProduct();
	setButtonCourse();
	setNoTierProductButton();

	getMemberInventoryLoginCashier();

	setFancySelect();

	groupNailExist = $('#group-nail').length;
	if(!groupNailExist){
		// NEW SALE MENU BUTTON
		setSaleButton();
	}
	setButtonSpecial();
	
	//add therapist
	$("#add_employee_form").submit(function(){
		return requireCheck();
	});
	$("#default_queue_form").submit(function(){
		latest_queue_date = $('#latest_queue_date').val();
		q_queue = Date.parse(latest_queue_date);
		latest_default_queue_date = $('#latest_default_queue_date').val();
		q_default = Date.parse(latest_default_queue_date);
		queue_date = $('#default_queue_form input[name=queue_date]').val();
		q_input = Date.parse(queue_date);
				
		pass = requireCheck();
		if(pass){
			if(latest_queue_date == "" && latest_default_queue_date == ""){
				if(q_input >= today){
					//alert("ไม่มีไรเลอ เลือกวันนี้เป็นต้นไปได้เลย");
					pass = false;
					$('.code_input').each(function(){
						if($(this).val() != ""){
							pass = true;
						}
					});
				}else{
					alert("Can not select the date in the past.");
					pass = false;
				}
			}else if(q_queue.toString() == q_input.toString()){
				//alert("ไม่สามารถ เพิ่ม/แก้ไข คิวเริ่มต้นที่มีการสร้างคิวประจำวันไปแล้วได้");
				if(confirm("มีคิวตั้งต้นอยู่ก่อนแล้วสำหรับวันนี้ หากต้องการเปลี่ยนแปลงจะมีผลกระทบถึงคิวประจำวันนี้ด้วย ยังอยากจะกดอยู่มั้ย?\r\n\r\nสิ่งที่จะได้รับผลกระทบ : \r\n⭕️ คิวตั้งต้นของวันนี้\r\n⭕️ คิวประจำวันนี้")){
					pass = true;
				}else{
					pass = false;
				}
			}
		}
		return pass;
	});

	// LABEL PRINTER
	$('.print_label_button').click(function(){
		loading();
		print_id = $(this).attr('data-print_id');
		if(print_id > 0){
			$.ajax({
				type 		:	"POST",
				url  		:	"ajax.php",
				data 		:	{command: "printMedicineLabel", print_id: print_id},
				dataType	:	"json",
				success		:	function(data){	
					console.log(data);
					
					$.ajax({
						type: "POST",
						url: data.endpoint,
						data: data.json_payload,
						dataType: "json",
						contentType: "application/json; charset=utf-8",
						crossDomain: true,
						beforeSend: function(){
							console.log("start printer");
						},
						success: function (data, status, jqXHR) {
							alert("Success");
							unload();
						}
					});
				}
			});
		}
	});
});

function getVoucherInput(){
	realtimeCalculation();
	// $.ajax({
	// 	type 		:	"GET",
	// 	data 		:	getdata,
	// 	url  		:	"ajax_new.php?command=calculate",
	// 	dataType	:	"json",
	// 	success		:	function(data){
	// 	}
	// });
}
function clearCal(){
	$('.value').html('');
}
function realtimeCalculation(callback){ //for product
	loading();

	// CHECK PRODUCT THAT CANNOT USE TIER DISCOUNT
	if(canUseTierDiscount()){
		$('.tier_percent_discount').prop('disabled', false);
	}else{
		$('.tier_percent_discount').prop('disabled', true);
	}

	vars = $('.payment_form').serialize();
	// console.log(vars);
	$.ajax({
		type 		:	"POST",
		url  		:	"ajax_new.php?command=calculate",
		data 		:	vars,
		dataType	:	"json",
		success		:	function(data){
			unload();
			console.log("script.js : realtimeCalculation(); : "+data.page);
			// console.log(data.page);

			// CLINIC
			if(data.pass == false){
				$('.dropzone .announce').remove();
				$('.dropzone').append('<div class="announce error">'+data.message+'</div>');
				clearCal();
				return false;
			}

			// TOKEN
			if(data.sum_token){
				$('input[name=sum_token]').val(data.sum_token);
				$('.payment_amount_input').val(data.grand_total).prop('readonly', true).prop('disabled', true);
				$('.token_total .value').html($.number(data.sum_token));
				newRealtimeCalculation();
			}
/*
			if(data.special_discount > 0){
				$('#payment_sum .payment_special_discount').show();
				$('#payment_sum .payment_special_discount .value').html("- "+$.number(data.special_discount));
			}else{
				$('#payment_sum .payment_special_discount').hide();
			}
*/
			// FROM STEP DISCOUNT
			$('.discount_percent_input').prop('readonly', false);
			has_tier_percent_discount = $('.tier_percent_discount').length;
			if(has_tier_percent_discount){
				// SKIP FILL DISCOUNT PERCENT
				$('.discount_percent_input').not('tier_percent_discount').prop('readonly', true);
			}
			if(data.discount_percent){
				$('.discount_percent_input').not('tier_percent_discount').prop('readonly', true);
			}
			
			$('#payment_sum .payment_paid .value').html($.number(data.paid, 2));
			$('#payment_sum .payment_balance .value').html($.number(data.balance, 2));

			$('#payment .sub_total .value').html($.number(data.sub_total, 2));
			$('#payment .discount .value').html($.number(data.discount, 2));
			$('#payment .before_total .value').html($.number(data.before_total, 2));
			if(data.page != 'product'){
				$('#payment .box.service, #payment .before_total').show();
			}else{
				$('#payment .box.service, #payment .before_total').hide();
			}
			
			$('#payment .service_charge .value').html($.number(data.service_charge, 2));
			$('#payment .vat .value').html($.number(data.government_tax, 2));
			
			
			$('#payment .grand_total .value, #payment_sum .payment_total .value').html($.number(data.grand_total, 2));
			$('input[name=payment_total]').val(data.grand_total);

			if((parseInt(data.paid) > 0 && parseInt(data.balance) == 0 && (parseInt(data.grand_total) >= 0 || data.page == "onsen")) || (data.page == "onsen" && data.balance == 0)){
				$('#payment_sum .padding').css("background-color","RGBA(0, 255, 0, 0.3)");
			}else{
				$('#payment_sum .padding').css("background-color","RGBA(255, 0, 0, 0.3)");
			}
			
			//cal live price for each item
			has_error = false;

			$('.product_group').each(function(){
				product_price = $(this).find('.product_price').val();
				quantity = $(this).find('.quantity').val();
				discount = $(this).find('.sub_discount').val();
				percent_discount = $(this).find('.sub_percent_discount').val();
				token = $(this).attr('token');
				
				// QAUNTITY
				if(quantity == undefined){
					quantity = 1;
				}

				// DISCOUNT
				if(percent_discount > 0){
					discount = quantity * product_price * (percent_discount / 100);
					$(this).find('.sub_discount').val("");
				}

				normal_price = product_price * quantity;
				live_price = normal_price - discount;
				live_token = token * quantity;
				if(live_price < 0){
					alert("Discount must be lower or equa to the product price.");
					$(this).find('.live_price').html("<span class='red'>error</span>");
					
					has_error = true;
				}else{
					if(live_price != normal_price){
						$(this).find('.live_price').html("<span class='green'>"+$.number(live_price)+"</span> <s class='grey'>"+$.number(normal_price)+"</s>");
					}else{
						$(this).find('.live_price').html("<span class='green'>"+$.number(live_price)+"</span>");
					}
					// TOKEN
					if(live_token){
						$(this).find('.live_token').html($.number(live_token)+' <i class="fas fa-coins"></i>');
					}
				}
			});
			if(has_error){
				$('button[name=submit_button]').attr("disabled", "disabled");
			}else if(!$('#banned_overlay').length){
				$('button[name=submit_button]').removeAttr("disabled");
			}

			// CONVERTED BALANCE
			convertedBalance(data.balance);

			// CALLBACK FUNCTION
			if(typeof callback === "function"){
				callback();
			}
		}
	});
}
function wizardSuccess(sub_command, value){
	loading();
	vars = $('#cashier_form, #new_cashier_form').serialize();
	if(sub_command == undefined){
		url = "ajax.php?command=wizard";
	}else{
		url = "ajax.php?command=wizard&sub_command="+sub_command+"&value="+value;
	}
	$.ajax({
		type		:	"POST",
		data		:	vars,
		dataType	:	"json",
		url			:	url,
		error		:	function(data){
			console.log(data);
		},
		success		:	function(data){
			unload();
			//$('#first').html(data);
			console.log(data);
			$('.wizardzone').html(data.show).fadeIn(200).removeClass('loading black');
			$('.button_no_wizard').click(function(){
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "clearSkipAll"},
					success	:	function(data){
						getSkipBox();
						clearWizard();
					}
				});
			});
			if(sub_command == undefined){
			}else{
				getSkipBox();
			}
			
			//skip button
			$('button.button_denied, button.button_skip').click(function(){
				command = $(this).attr("command");
				employee_id = $(this).val();
				if(confirm(command+"?")){
					wizardSuccess(command, employee_id);
				}
			});
		}
	});
	$('#auto_therapist_wizard').modal('hide');
}
function setButtonSpecial(){
	$('.special_button').click(function(){
		// DISABLED AFTER CLICK
		$(this).prop('disabled', true);

		$.ajax({
			type	:	"POST",
			dataType:	"json",
			data	:	{command: "getSpecialInput", index_id: current_product},
			url		:	"ajax.php",
			success	:	function(data){
				$('.dropzone').append(data.show);
				setNumberOnly();
				$('.dropzone .auto_product_no_price').autocomplete({
					source: path+"ajax_autocomplete.php?type=product_no_price",
					minLength: 0,
					autoFocus: true,
					select:	function(event, ui){
						serial = ui.item.serial;
					},
					close: function(){
						realtimeCalculation();
					}
				});

				parent = $('.special_group'+current_product);
				parent.find('.button.remove').click(function(){
					to_delete = $(this).parent().parent().parent();
					if(confirm(confirm_delete)){
						to_delete.remove();
						realtimeCalculation();
					}
				});
				parent.find('.live_cal').change(function(){
					realtimeCalculation();
				});
				current_product++;
				$('.special_button').prop('disabled', false);
			}
		});
	});
}
function setButtonDeliveryProduct(){
	console.log('setButtonDeliveryProduct');
	$('.delivery_product_button').click(function(){
		item_type = $(this).attr("item_type");

		if(getIndexNumber() == 0){
			index = current_product = 1;
		}else{
			index = current_product = getIndexNumber() + 1;
		}

		$.ajax({
			type	:	"POST",
			dataType:	"json",
			data	:	{command: "getDeliveryProductInput", index_id: current_product, item_type: item_type},
			url		:	"ajax.php",
			success	:	function(data){
				// console.log(data);
				index_id = data.index_id;
				$('.dropzone').append(data.show);
				setNumberOnly();
				$('.dropzone .auto_all_product').autocomplete({
					source: path+"ajax_autocomplete.php?type="+item_type,
					minLength: 1,
					autoFocus: true,
					select:	function(event, ui){
						// console.log(ui);
						// console.log("select");
						if(item_type == "goods"){
							// GOODS
							ItemCode = ui.item.ItemCode;
							ItemName = ui.item.ItemName;
							toCheck = ItemCode;
						}else{
							serial = ui.item.serial;
							product_id = ui.item.product_id;
							toCheck = product_id;
						}
						is_dup = checkDuplicateProduct(toCheck);
					},
					close:	function(event, ui){
						// console.log("close");
						if(typeof toCheck == 'undefined'){
							$(this).val("");
							alert('Please select item from the list.');
						}else{
							if(is_dup){
								//error
								$(this).val("");
								alert("Already add this item.");
							}else{
								if(item_type == "goods"){
									$(this).parent().parent().find('.ItemCode').val(ItemCode);
									$(this).parent().parent().find('.ItemName').val(ItemName);
								}else{
									$(this).parent().parent().find('.quantity').attr('serial', serial);
									$(this).parent().parent().find('.product_id').val(product_id);
								}
							}
						}
					},
					change: function(event, ui){
						// console.log("change");
						if(ui.item === null){
							alert('This item is not exist.')
							$(this).val("");
						}
					}
				});
				parent = $('.product_group'+index_id);
				parent.find('.button.remove').click(function(){
					to_delete = $(this).parent().parent().parent();
					if(confirm(confirm_delete)){
						to_delete.remove();
						updateIndexNumber();
					}
				});
				updateIndexNumber();
			}
		});
		current_product++;
	});
}
function setButtonCourse(){
	console.log('course button');
	
	current_product = 1;
	$('.course_button').click(function(){
		// DISABLED AFTER CLICK
		$(this).prop('disabled', true);

		// MAKE REQUIRE
		$('#inventory-login').addClass("highlight").removeClass('cool');
		$("#customer_email_telephone, #member_id").addClass("require").prop('required', true);
		
		$.ajax({
			type	:	"POST",
			dataType:	"json",
			data	:	{command: "getCourseInput", index_id: current_product},
			url		:	"ajax.php",
			success	:	function(data){
				$('.dropzone').append(data.show);
				setNumberOnly();
				$('.dropzone .auto_course').autocomplete({
					source: path+"ajax_autocomplete.php?type=course",
					minLength: 1,
					autoFocus: true,
					select:	function(event, ui){
						product_id = ui.item.product_id;
						category_id = ui.item.category_id;
						product_brand_id = ui.item.product_brand_id;
						product_price = ui.item.price;
						serial = ui.item.serial;
						category_slug = ui.item.category_slug;
						use_tier_discount = ui.item.use_tier_discount;
						$(this).parent().parent().find('.quantity').attr('serial', serial);
						$(this).parent().parent().find('.product_price').val(product_price);
						$(this).parent().find('.product_id').val(product_id);

						// CONTAINER
						container = $(this).parent().parent().parent();
						container.attr('product_id', product_id);
						container.attr('category_id', category_id);
						container.attr('product_brand_id', product_brand_id);
						container.attr('category_slug', category_slug);
						container.attr('use_tier_discount', use_tier_discount);

						// MAKE READONLY
						$(this).prop('readonly', true);
					},
					close: function(){
						realtimeCalculation();
					}
				});

				parent = $('.product_group'+current_product);
				parent.find('.button.remove').click(function(){
					to_delete = $(this).parent().parent().parent();
					if(confirm(confirm_delete)){
						to_delete.remove();
						realtimeCalculation();
					}
				});
				parent.find('.live_cal').change(function(){
					realtimeCalculation();
				});
				current_product++;
				$('.course_button').prop('disabled', false);
			}
		});
	});
}
function setNoTierProductButton(){
	// ALERT IF HAS TIER DISCOUNT
	$('.no_tier_discount_product_button').click(function(){
		product_type = $(this).attr('product_type');

		// CHECK TIER DISCOUNT
		var product_cannot_use_tier_discount = new Array('course', 'voucher', 'special', 'wallet_topup', 'therapist_product', 'member_pass');
		has_tier_percent_discount = $('.tier_percent_discount').length;
		if(has_tier_percent_discount && product_cannot_use_tier_discount.indexOf(product_type) != -1){
			alertme('Member privilege does not apply with this product');
		}

		// CHECK WALLET TOPUP
		checkWalletProduct();

		onsen_card_exist = $("input[product_type=onsen_card]").length;
		if(onsen_card_exist){
			$(".wallet_payment_input").val(0).prop("disabled", true);
		}

		member_pass_exist = $("input[product_type=member_pass]").length;
		if(member_pass_exist){
			$(".discount_point_input").val(0).prop("disabled", true);
		}
	});
}

function checkWalletProduct(){
	if(typeof product_type == 'undefined'){
		var product_type;
	}
	has_wallet_box = $('#use-wallet-box').length;
	var product_cannot_use_wallet = new Array('wallet_topup', 'member_pass');
	if(has_wallet_box && product_cannot_use_wallet.indexOf(product_type) != -1){
		$(".wallet_payment_input").val(0).prop("disabled", true);
	}else{
		$(".wallet_payment_input").val(0).prop("disabled", false);
	}
}
function setButtonProduct(){
	current_product = 1;
	token_press_count = 0;
	
	$('.voucher_button').click(function(){
		// MAKE REQUIRE
		$('#inventory-login').addClass("highlight").removeClass('cool');
		$("#customer_email_telephone, #member_id").addClass("require").prop('required', true);
	});

	$('.product_button').click(function(){
		// DISABLED AFTER CLICK
		$(this).prop('disabled', true);

		product_type = $(this).attr('product_type');

		// DISABLE OTHER BUTTON
		if(product_type == 'wallet_topup'){
			$('.product_button[product_type!=wallet_topup], .special_button, .course_button, .separator').remove();
		}
		if(product_type == 'onsen_card'){
			$('.product_button[product_type!=onsen_card], .special_button, .course_button, .separator').remove();
		}

		if(product_type == 'token'){
			$('.product_button[product_type!=token], .special_button, .course_button, .separator').remove();
			if(!token_press_count){
				$.ajax({
					type	:	"POST",
					data	:	{command: "getPaymentType", page: "product", token: true},
					dataType:	"json",
					url		:	"ajax.php",
					success	:	function(data){
						$('#third #payment_type').html(data.show);
						newRealtimeCalculation();

						// SUBMIT BUTTON
						$('.submit_payment').click(function(){
							checkOnProductPageSubmit();
						});
						
						// LIVE CAL
						$('.live_cal').change(function(){
							newRealtimeCalculation();
						});
					}
				});
				token_press_count++;
			}
		}

		$.ajax({
			type	:	"POST",
			dataType:	"json",
			data	:	{command: "getProductInput", index_id: current_product, product_type: product_type},
			url		:	"ajax.php",
			success	:	function(data){
				// console.log(data);
			$('.dropzone').append(data.show);
				setNumberOnly();
				// console.log(data.product_group);
				$(".dropzone ."+data.product_group+" .auto_product").autocomplete({
					source: path+"ajax_autocomplete.php?type="+data.product_type,
					minLength: 1,
					autoFocus: true,
					select:	function(event, ui){
						product_id = ui.item.product_id;
						category_id = ui.item.category_id;
						product_brand_id = ui.item.product_brand_id;
						product_price = ui.item.price;
						serial = ui.item.serial;
						category_slug = ui.item.category_slug;
						use_tier_discount = ui.item.use_tier_discount;
						token = ui.item.token;
						
						remark = ui.item.remark;
						voucher_remark = ui.item.voucher_remark;
						// voucher_name = ui.item.voucher_name;
						// voucher_refcode = ui.item.voucher_refcode;

						$(this).parent().parent().find('.product_id').val(product_id);
						$(this).parent().parent().find('.product_price').val(product_price);
						$(this).parent().parent().find('.quantity').attr('serial', serial);
						$(this).parent().parent().find('.token').val(token);
						
						$(this).parent().parent().find('.product-remark').html(voucher_remark);

						// CONTAINER
						container = $(this).parent().parent().parent();
						container.attr('product_id', product_id);
						container.attr('category_id', category_id);
						container.attr('product_brand_id', product_brand_id);
						container.attr('category_slug', category_slug);
						container.attr('use_tier_discount', use_tier_discount);
						container.attr('token', token);

						// MAKE READONLY
						$(this).prop('readonly', true);
					},
					close: function(event, ui){
						reApplyVoucher();

						// SET WIDTH
						width = (((this.value.length + 1) * 8) + 10) + 'px';
						$(this).width(width);

						// DISABLED TIER DISCOUNT
						if(data.product_type == 'wallet_topup'){
							$('.discount_percent_input').prop('disabled', true);
						}
						realtimeCalculation();	
					}
				});

				parent = $('.product_group'+current_product);
				parent.find('.button.remove').click(function(){
					to_delete = $(this).parent().parent().parent();
					if(confirm(confirm_delete)){
						to_delete.remove();
						reApplyVoucher();
						realtimeCalculation();
					}
				});
				parent.find('.live_cal').change(function(){
					realtimeCalculation();
				});
				current_product++;
				$('.product_button').prop('disabled', false);

				blockCashDiscount();
			}
		});
	});
}
function requireCheck(check){
	pass = true;
	radio_pass = false;
	has_radio = false;

	var radio = new Array();
	var total_radio_pass = 0;
	var previous_name = '';
	$('.require:visible').each(function(){
		// DEBUG
		if(check == true){
			console.log($(this).attr('name')+" : "+$(this).val());
		}

		// RADIO
		if($(this).is(':radio')){
			name = $(this).attr('name');
		
			has_radio = true;
			if(name != previous_name){
				radio.push(name);
				previous_name = name;
			}
			
			if($(this).is(':checked')){
				total_radio_pass += 1;
			}
			// console.log($(this).attr('name')+' - '+$(this).val()+' - '+$(this).is(':checked'));
		}else{
			// NORMAL
			if($(this).val() == ''){
				pass = false;
			}
		}
	});

	// console.log(radio);
	// console.log(radio.length+' - length');
	// console.log(total_radio_pass+' - total_radio_pass');
	if(radio.length == total_radio_pass){
		radio_pass = true;
	}

	// console.log(has_radio+' - '+radio_pass+' - '+radio.length+' - '+total_radio_pass);

	if(!pass || (has_radio && !radio_pass)){
		if(check == 'no-alert'){
			// SKIP ALERT
		}else{
			alert('Please make sure all required fields are filled out correctly');
		}
		return false;
	}else{
		return true;
	}
}
function clearWizard(){
	$('.wizardzone').fadeOut(200, function(){
		$(this).html('');
	});
	$('.dropzone').fadeTo(200, 1).removeClass('disable');
}
function isValidEmailAddress(email) {
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    return pattern.test(email);
};
function checkFileExtension(file, extension){
	file = file.toLowerCase();
	extension = extension.toLowerCase();
	raw_pattern = "^.*\.("+extension+")$";
	var pattern = new RegExp(raw_pattern);
	pass = pattern.test(file);
	if(pass){
	}else{
		alert("Please use the '"+extension+"' file.");
	}
	return pass;
}
function copyToClipboard(text){
	var dummy = document.createElement("textarea");
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
}
function copyToClipboardCrossbrowser(s) {           
	s = document.getElementById(s).value;               

	if( window.clipboardData && clipboardData.setData )
	{
		clipboardData.setData("Text", s);
	}           
	else
	{
		// You have to sign the code to enable this or allow the action in about:config by changing
		//user_pref("signed.applets.codebase_principal_support", true);
		netscape.security.PrivilegeManager.enablePrivilege('UniversalXPConnect');

		var clip = Components.classes["@mozilla.org/widget/clipboard;1"].createInstance(Components.interfaces.nsIClipboard);
		if (!clip) return;

		// create a transferable

		var trans = Components.classes["@mozilla.org/widget/transferable;1"].createInstance(Components.interfaces.nsITransferable);
		if (!trans) return;

		// specify the data we wish to handle. Plaintext in this case.
		trans.addDataFlavor('text/unicode');

		// To get the data from the transferable we need two new objects
		var str = new Object();
		var len = new Object();

		var str = Components.classes["@mozilla.org/supports-string;1"].createInstance(Components.interfaces.nsISupportsString);

		str.data= s;        

		trans.setTransferData("text/unicode",str, str.data.length * 2);

		var clipid=Components.interfaces.nsIClipboard;              
		if (!clip) return false;
		clip.setData(trans,null,clipid.kGlobalClipboard);      
	}
}
function setNumberOnly(){
	$("input.number").unbind('keydown').keydown(function(event) {
		// console.log(event);
        // Allow: backspace, delete, tab, escape, enter and . (and num pad .)
        if ( $.inArray(event.keyCode,[46,8,9,27,13,190,110]) !== -1 ||
             // Allow: Ctrl+A
            (event.keyCode == 65 && event.ctrlKey === true) || 
             // Allow: home, end, left, right
            (event.keyCode >= 35 && event.keyCode <= 39)) {
                 // let it happen, don't do anything
                 return;
        }else{
            // Ensure that it is a number and stop the keypress
            if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
                event.preventDefault(); 
            }   
        }
    });
}
function getSkipBox(){
	$('#skip_therapist').load('ajax.php?command=getSkipBox', function(){
		//skip
		$('#skip_therapist .put_back_skip, #skip_therapist .clear_skip_all').click(function(){
			employee_id = $(this).val();
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "clearSkipAll", employee_id: employee_id},
				success	:	function(data){
					getSkipBox();
					$('.dropzone').fadeTo(200, 0.2).addClass('disable');
					$('.wizardzone').html('').fadeIn(200).addClass('loading black');
					wizardSuccess();
				}
			});
		});
	});
}
function loading(){
	$('body').append('<i class="main loading fas fa-spinner fa-spin fa-2x"></i>');
}
function unload(){
	$('.main.loading').remove();
}
function getURLParameter(name) {
    return decodeURI(
        (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]
    );
}
function approveCard(card_id){
	if(confirm("Approve this card?")){
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "approvecard", card_id: card_id},
			success	:	function(data){
				window.setTimeout('location.reload()', 0);
			}
		});
	}else{
		return false;
	}
}
function getIndexNumber(){
	if(typeof index == 'undefined'){
		index = $('.product_group').length;
	}
	return index;
}
function updateIndexNumber(){
	getIndexNumber();
	i = 1;
	$('.product_group').each(function(){
		$(this).find('label.number').html(i);
		i++;
	});
}

function setDeliveryButton(){
	$('button.stock_delivery').click(function(){//ปุ่มส่งของสีเหลือง
		stock_id = $(this).attr('stock_id');
		if(confirm("Confirm delivery?")){
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "stock_delivery", stock_id: stock_id},
				success	:	function(data){
					location.reload();
				}
			});
		}
	});
	$('button.stock_delete').click(function(){//ปุ่มลบสีแดง
		stock_id = $(this).attr('stock_id');
		if(confirm("Delete this delivery?")){
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "stock_delete", stock_id: stock_id},
				success	:	function(data){
					location.reload();
				}
			});
		}
	});
}
function checkDuplicateProduct(selected_product_id){
	is_dup = false;
	$('.product_id, .ItemCode').each(function(){
		current = $(this).val();
		// console.log(selected_product_id+" | "+current);
		if(selected_product_id == current){
			is_dup = true;
		}
	});
	return is_dup;
}
function checkFinalApproveStockDebit(date){
	// CHECK FINAL APPROVE
	$.ajax({
		type	:	"POST",
		dataType:	"json",
		url		:	"ajax.php",
		data	:	{command: "get_approve_status", date: date},
		success	:	function(data){
			if(data){
				$('.approve_status').remove();
				if(data.final_approve == 0 || data.final_approve === undefined || data.final_approve == null){
					$('#third, #product_section').show();
				}else{
					$('#third, #product_section').hide();
					$('#main_body, #admin.delivery_transfer, form[name=delivery_form]').append("<div class='announce approve_status error'>This month is already do the final approve.</div>");
				}
			}
		}
	});
}

function setPINButton(){
	//PIN
	$('.pin-approve').click(function(){
		reset_request_id = $(this).attr('reset_request_id');
		if(confirm("Confirm this PIN reset request?")){
			$.ajax({
				type	:	"GET",
				url		:	"ajax.php",
				data	:	{command: "approvepinchange", reset_request_id: reset_request_id},
				success	:	function(data){
					$(".dropzone").html(data);
					setPINButton();
				}
			});
		}
	});
	$('.pin-change').click(function(){
		card_id = $(this).attr('card_id');
		reset_request_id = $(this).attr('reset_request_id');
		$.ajax({
			type	:	"GET",
			url		:	"ajax.php",
			data	:	{command: "getchangepinbox", card_id: card_id, reset_request_id: reset_request_id},
			success	:	function(data){
				$('body').append(data);
				$('.popup').fadeIn(200);
				b_height = $('.change-pin-box').height() + 10;
				$('.popup').height(b_height);

				// SET BUTTON
				$('button[name=submit-change-pin]').click(function(){
					new_pin = $('input[name=new-pin]').val();
					confirm_new_pin = $('input[name=confirm-new-pin]').val();
					if(new_pin == confirm_new_pin && new_pin != ""){
						$('form[name=change-pin-form]').submit();
					}else{
						alert("Two PIN field must be the same and not empty.");
					}
				});

				$('button[name=close-change-pin]').click(function(){
					$('.popup').fadeOut(200, function(){
						$(this).remove();
					});
				});
			}
		});
	});
}

//blink
function blinker() {
    $('.noti').fadeOut(200);
    $('.noti').fadeIn(500);
}
setInterval(blinker, 2000); //Runs every second

function ValidateDate(dtValue){
	var dtRegex = new RegExp(/\b\d{4}[\/-]\d{1,2}[\/-]\d{1,2}\b/); // yyyyy/mm/dd or yyyy-mm-dd
	return dtRegex.test(dtValue);
}
function toolltips(text, event){
	tooltips_exist = $('#tooltips').length;
	if(!tooltips_exist){
		$('body').append('<div id="tooltips"></div>');	
	}
	$('#tooltips').html('<i class="fa fa-times-circle close" aria-hidden="true"></i>'+text).hide().fadeIn(100);
	$('#tooltips').css('top', event.pageY);
	$('#tooltips').css('left', event.pageX);
	$('#tooltips .close').click(function(){
		$('#tooltips').fadeOut(100, function(){
			$(this).remove();
		})
	});
}
function popup(){
	height = $('.popup div').height();
	$('.popup').height(height);
	$('.popup .close_popup').click(function(){
		$('.popup').fadeOut(100);
	});
	setNumberOnly();
}
function getCardType(credit_card_no, element){
	$.ajax({
		type	:	"POST",
		url		:	"ajax.php",
		data	:	{command: "getCardType", credit_card_no: credit_card_no},
		success	:	function(data){
			element.val(data);
		}
	});
}
function setCreditCardNext(){
	// CREDIT CARD NEXT INPUT
	$(".first .inputs").keyup(function () {
		card_type_obj = $(this).parent().parent().parent().parent().parent().find(".creditcard_type");
		getCardType($(this).val(), card_type_obj);
		if ($(this).val().length == $(this).attr("maxlength")) {
			next = $(this).parent().parent().find(".last .inputs");
			next.focus();
		}
	});
}
function setEDC(){
	$('.edc-logo').click(function(){
		$(this).parent().find('.edc-logo').removeClass('selected');
		$(this).addClass('selected');
	});
}
function db(code){
	console.log(code);
}
function checkTherapistEdit(){
	therapist_status = $('select[name=status]').val();
	if(therapist_status == 'inactive'){
		// CHECK quit_date
		if($('input[name=quit_date]').val() == ''){
			alert('ป้อน end work date (วันที่ที่หมอลาออก) ด้วย หากหมอ inactive');
			$('input[name=quit_date]').addClass('require').focus();
			return false;
		}else{
			return true;
		}
	}else{
		$('input[name=quit_date]').removeClass('require');
		return false;
	}
}

function checkCustomerInput(){
	if(
		$('#customer_firstname').val() == '' &&
		($('#customer_telephone').val() == '' && $('#customer_email').val() == '')
	){
		return false;
	}else{
		return true;
	}
}

function alertme(body, title){
	getModal(body, title);
}
function getModal(body, title){
	if(title != undefined){
		$('#modal .modal-title').html(title).removeClass('center');
		$('#modal .modal-body').html(body).show();
	}else{
		$('#modal .modal-title').html(body).addClass('center');
		$('#modal .modal-body').hide();
	}
	$('#modal .modal-footer').html('<button type="button" class="btn btn-cool-invert" data-dismiss="modal">Close</button>');
	$('#modal').modal('show');
}

function getConfirm(body, title, button2_label, button3_label){
	if(typeof button2_label == 'undefined'){
		button2_label = 'Submit';
	}

	if(typeof button3_label == 'undefined'){
		button3_label = false;
	}

	$('#modal .modal-title').html(title).addClass('center');
	if(typeof body == 'undefined' || body == ''){
		$('#modal .modal-body').hide();
	}else{
		$('#modal .modal-body').html(body).show();
	}

	$('#modal .modal-footer').html('<button type="button" class="btn button btn-cool cancel" data-dismiss="modal">Close</button>');

	if(button2_label){
		if(button2_label == 'hide'){
			// DO NOTHING
		}else{
			$('#modal .modal-footer').html('<button type="button" class="btn button btn-cool cancel" data-dismiss="modal">Close</button><button type="button" class="confirm btn button btn-cool-invert">'+button2_label+'</button>');
		}
	}else{
		$('#modal .modal-footer').html('<button type="button" class="btn button btn-cool cancel" data-dismiss="modal">Close</button>');
	}

	if(button3_label){
		$('#modal .modal-footer').append('<button type="button" class="optional btn button btn-optional">'+button3_label+'</button>');
	}
	$('#modal').modal('show');
}
function bookingPicker(){
	$('.date_input_booking').datepicker({
		dateFormat:'yy-mm-dd',
		showButtonPanel: true,
		minDate: 0,
		maxDate: "+12m",
		onClose: function(dateText, inst) {
			$(this).prop('readonly', true);
		}
	});
	$('.time_input_booking').timepicker({
		"showCloseButton"	:	true,
		"minTime"				:	{
			"hour" : 8
		},
		"onSelect"			:	function(){
			$(this).prop('readonly', true);
			$('input[name=treatment_hour]').val($(this).timepicker('getHour'));
			$('input[name=treatment_minute]').val($(this).timepicker('getMinute'));
		}
	});
}

/**
 * เอาไว้ปิดช่องที่เกี่ยวกับ discount และการเปลี่ยนราคาให้หมด
 * ! ใช้ตอนสแกน cashcard เพื่อไม่ให้เกิดส่วนลดแฝง
 */
function closeAllDiscountRelateInput(){
	console.log('Closed All Discount Input');
	$('.discount_input, .new_price_input').val('').prop('disabled', true);
	newRealtimeCalculation();
}

/**
 * กดปุ่ม submit ในหน้า product แล้วจะรันฟังก์ชั่นนี้
 */
function checkOnProductPageSubmit(){
	console.log('checkOnProductPageSubmit');
	pass = requireCheck();
	if(pass){
		payment_button = $('button.submit_payment');

		// CHECK PRODUCT UNITS
		$('.product_group input.quantity').each(function(){
			if($(this).val() == 0){
				pass = false;
			}
		});

		if(!pass){
			alert('Product amount must be greater than 0 / จำนวนสินค้าต้องมีอย่างน้อย 1 ชิ้น');
		}else{
			if(!$('#customer_email_telephone').prop('required')){
				pass = true;
				// DATA
				getdata = $('#cashier_form').serialize();

				// MAKE THE BUTTON DISABLED WHEN CLICK TO AVOID DUPLICATE WHEN INTERNET IS SLOW
				payment_button.prop('disabled', true);
				$.ajax({
					type 		:	"POST",
					data 		:	{"command" : "checkall", "data" : getdata},
					url  		:	"ajax.php",
					dataType	:	"json",
					error		:	function(){
						alert("There is something wrong with the system, please try again.");
						payment_button.prop('disabled', false);
						return false;
					},
					success		:	function(data){
						payment_button.prop('disabled', false);
						// console.log(data.receipt_no);
						if(data.pass){
							if(confirm("Submit this order?")){
								$('#cashier_form').submit();
								return true;
							}else{
								return false;
							}
						}else{
							if(data.cool_alert){
								alertme(data.message, data.title);
							}else{
								alert(data.message);
							}
							return false;
						}
					}
				});
			}else{
				checkMemberExist($('#customer_email_telephone').val(), function(){
					// DATA
					getdata = $('#cashier_form').serialize();
					payment_button.prop('disabled', true);
					$.ajax({
						type 		:	"POST",
						data 		:	{"command" : "checkall", "data" : getdata},
						url  		:	"ajax.php",
						dataType	:	"json",
						error		:	function(){
							alert("There is something wrong with the system, please try again.");
							payment_button.prop('disabled', false);
							return false;
						},
						success		:	function(data){
							// console.log(data);
							payment_button.prop('disabled', false);
							if(data.pass){
								if(confirm("Complete the reservation?")){
									$('#cashier_form').submit();
									return true;
								}else{
									return false;
								}
							}else{
								if(data.cool_alert){
									alertme(data.message, data.title);
								}else{
									alert(data.message);
								}
								return false;
							}
						}
					});
				});
				return false;
			}
		}
	}
	return false;
}

/**
 * dropdown ที่จะใช้ point ต้องรันตัวนี้ด้วย
 */
function setUsePointDropdown(){
	console.log('setUsePointDropdown');
	$(".discount_point_input").change(function(){
		selected_option = $(this).find("option:selected");
		parent = $(this).parent();
		parent.find("input.point_use").val(selected_option.attr("data-point"));
		parent.find(".console").removeClass("hide");
		parent.find(".point-use .value").text($.number(selected_option.attr("data-point"))).parent();
		parent.find(".point-left .value").text($.number(selected_option.attr("data-left"))).parent();
	});
	setPaymentType();
}

/**
 * getPaymentType
 * ใช้ดึง payment type form ในส่วนที่เกี่ยวกับการจ่ายเงิน
 * @param {integer} member_id 
 * @param {string} page 
 * @param {string} sub_page 
 */
function getPaymentType(member_id, page, sub_page){
	booking_id = $('input[name=booking_id]').val();
	$.ajax({
		type	:	"POST",
		data	:	{command: "getPaymentType", page: page, sub_page: sub_page, member_id: member_id, booking_id: booking_id},
		dataType:	"json",
		url		:	"ajax.php",
		success	:	function(data){
			// console.log(data);
			$('#third').html(data.show);
			newRealtimeCalculation();

			// SUBMIT BUTTON
			$('button.submit_payment, button.submit').click(function(){
				checkOnProductPageSubmit();
			});
			
			// LIVE CAL
			$('.live_cal').change(function(){
				newRealtimeCalculation();
			});
		}
	});
}
function getMemberPaymentType(member_id, page, sub_page){
	booking_id = $('input[name=booking_id]').val();
	$.ajax({
		type	:	"POST",
		data	:	{command: "getMemberLoggedInPayment", page: page, sub_page: sub_page, member_id: member_id, booking_id: booking_id},
		dataType:	"json",
		url		:	"ajax.php",
		success	:	function(data){
			console.log(data);
			$('#member-dropzone').html(data.show);
			newRealtimeCalculation();

			// SUBMIT BUTTON
			$('button.submit_payment, button.submit').click(function(){
				checkOnProductPageSubmit();
			});
			
			// LIVE CAL
			$('.live_cal').change(function(){
				newRealtimeCalculation();
			});
		}
	});
}function handleBannedMember(data, container){
	var $c = $(container);
	$c.find('.banned-warning, .ban-reason').remove();
	$('#banned_overlay').remove();
	$('button[name=submit_button], button.submit_payment, button.submit').prop('disabled', false);
	if(data && data.status === 'banned'){
		$c.prepend('<div class="banned-warning announce error"><i class="fas fa-ban"></i> This member is <strong>banned</strong></div>');
		if(data.ban_remark){
			$c.find('.banned-warning').after('<div class="ban-reason"><i class="fas fa-exclamation-triangle"></i> '+data.ban_remark+'</div>');
		}
		$('body').append('<div id="banned_overlay"><div class="banned_watermark">BANNED</div></div>');
		$('button[name=submit_button], button.submit_payment, button.submit').prop('disabled', true);
		return true;
	}
	return false;
}function checkMemberExist(customer_email_telephone, callback){
	$.ajax({
		type	:	"POST",
		url		:	"ajax.php",
		data	:	{command: "checkMemberTelephoneEmail", customer_email_telephone: customer_email_telephone},
		dataType:	"json",
		success	:	function(data){
			if(data.pass){
				if(handleBannedMember(data, '.email-telephone-box')){
					$('#customer_name').val('');
					if(typeof callback == "function"){
						alert('Member is banned');
					}
					return;
				}
				$('#inventory-login').find('.email-telephone-box').addClass('bg_pass_green').removeClass('cool bg_red');
				$('#customer_name').val(data.fullname);

				if(typeof callback == "function"){
					callback();
				}
			}else{
				$('#inventory-login').find('.email-telephone-box').addClass('bg_red').removeClass('cool bg_pass_green');
				$('#customer_name').val(data.fullname);
				handleBannedMember(null, '.email-telephone-box');
				if(typeof callback == "function"){
					alert("ไม่ได้เป็นสมาชิก / เบอร์โทรศัพท์ หรือ email สมาชิกไม่ถูกต้อง");
				}
			}
			// LOGIN
			if(typeof data.login_status !== 'undefined'){
				$('#loginStatus').val(data.login_status);
			}
		}
	});
}

function setPaymentType(){
	$('.payment_type').change(function(){
		loading();
		this_obj = $(this);
		index_id = this_obj.attr('index_id');
		payment_amount = parseInt($(this).parent().parent().parent().parent().find('.payment_amount_input').val(), 10);

		// CITY(VAT) & TRANSFER DEPOSIT & FOC
		if(payment_type_id == 8 || payment_type_id == 13 || payment_type_id == 10){
			window.has_exclude_tier_discount_payment = true;
			tier_discount_exist = $('#tier-discount').length;
			if(tier_discount_exist){
				getModal('ถ้าเลือก City(Vat) / Transfer Deposit หรือ FOC จะใช้ Tier Discount ไม่ได้');
			}
		}
		getPaymentSub(payment_type_id, index_id, this_obj);

		// SPECIAL ACTION
		// in_payment_type_id
		count_in_payment_type_id = $('.voucher_box.in_payment_type_id').length;
		if(count_in_payment_type_id > 0){
			$('.voucher_box.in_payment_type_id').each(function(){
				parent = $(this);
				code = $(this).attr('voucher');
				removeCardVoucherInside(code, parent);
			});
			$('.voucher_message.error').hide();
		}
	});

	// POINT & WALLET
	$('.wallet_payment_input, .discount_point_input').change(function(){
		// in_payment_type_id
		count_in_payment_type_id = $('.voucher_box.in_payment_type_id').length;
		if(count_in_payment_type_id > 0){
			$('.voucher_box.in_payment_type_id').each(function(){
				parent = $(this);
				code = $(this).attr('voucher');
				removeCardVoucherInside(code, parent);
			});
			$('.voucher_message.error').hide();
		}
	});
}

function getPaymentSub(payment_type_id, index_id, this_obj, additional = null){
	payment_detail_box = this_obj.parent().parent().parent().parent().parent().find('.payment_detail_box');
	payment_type_id = this_obj.val();

	$.ajax({
		type : "POST",
		url : "ajax.php",
		dataType : "json",
		data : {command: "getPaymentSub", payment_type_id: payment_type_id, index_id: index_id, additional: additional},
		success : function(data){
			unload();
			parent_box = this_obj.parent().parent().parent().parent().parent();
			amount = parent_box.find('.payment_amount_input');
			disabled_detail_box = parent_box.find('.payment_detail_box');
			
			if(data.foc){
				$('.payment_type').not(this_obj).val('').prop('disabled', true);
				disabled_detail_box.html('');
				// amount.val('').prop('disabled', true);
				$('input[name=is_foc]').val(true);
			}else{
				$('.payment_type').prop('disabled', false);
				amount.prop('disabled', false);
				$('input[name=is_foc]').val(false);
			}			
			realtimeCalculation();
			payment_detail_box.html(data.show);

			// EDC
			setEDC();
			setCreditCardNext();
		}
	});
}

/**
 * ใช้โหลดพวกกล่อง member login หน้า AddPayment ทั้งใช้ใน Onsen ด้วย
 */
function getCashierMemberLogin(){
	$('button[name=card-login]').click(function(){
		$('.card-login').removeClass('hide');
	});
	$('button[name=search_card], button[name=search_card_reset]').click(function(){
		card_query = $('input[name=card_query]').val();
		button_name = $(this).attr("name");
		if(button_name == "search_card"){
			use_command = "cardQuery";
		}else{
			use_command = "cardQueryReset";
		}
		$.ajax({
			type	:	"POST",
			data	:	{command: use_command, card_query: card_query},
			dataType:	"json",
			url		:	"ajax.php",
			success	:	function(data){
				$('.card-login-user-box').html(data.user_show);
				$('#scanbox-card').hide().html(data.show).fadeIn(50);

				// SETTING FOR PIN RESET REQUEST
				$('#scanbox-card button[name=request_password_reset]').click(function(){
					card = $(this).parent();
					reason = prompt("Please input the reason, why have to reset this card's PIN?\r\nกรุณาระบุเหตุผลที่ต้องการเปลี่ยนรหัสใหม่");
					if(reason){
						var card_id = $(this).attr('card_id');
						$.ajax({
							type	:	"POST",
							url		:	"ajax.php",
							data	:	{command: "requestpinreset", card_id: card_id, reason: reason},
							success	:	function(){
								card.parent().append("<div class='press_title green center'>REQUESTED</div>");
								card.remove();
							}
						});
					}
				});


				pin_exist = $('input[name=pin]').length;
				code = data.code;
				doCardBoxClose();
				if(pin_exist){
					// SET SUBMIT PIN
					$('button.submit-pin').click(function(){
						button = $(this);
						pin = $(this).parent().find('input[name=pin]').val();
						card_no = $(this).parent().find('input[name=pin]').attr('card_no');
						parent_box = $(this).parent().parent().parent().parent();
						if(pin != ""){
							$.ajax({
								type	:	"post",
								data	:	{command: "submitPin", card_no: card_no, pin: pin, use_command: use_command},
								dataType:	"json",
								url		:	"ajax.php",
								success	:	function(data){
									// console.log(data);
									if(data.pass){
										closeAllDiscountRelateInput();
										button.parent().parent().parent().fadeOut(200, function(){
											$(this).remove();
											// console.log(data.show);
											// alert(parent_box.attr('class'));
											if(data.value.foc){
												$('#scanbox-card .box').hide();
											}
											parent_box.append(data.show).show();
											setCardInput();
											doCardBoxClose();
										});
									}else{
										alert(data.text);
									}
								}
							});
						}
					});
				}else{
					doCardBoxClose();
					setCardInput();
				}
			}
		});
	});

	// CASHIER MEMBER CARD LOGIN
	$('#payment_type_select input[name=card_query]').on('keypress', function(e) {
		var code = e.keyCode || e.which;
		if(code == 13){
			loadMemberCardInCashier();
			getMemberInventoryLogin();
		}
	});
	$('button[name=search_card_login]').click(function(){
		loadMemberCardInCashier();
		getMemberInventoryLogin();
	});
}

function loadMemberCardInCashier(){
	// CLEAR FOC
	$('.discount_percent_input').val("");
	$('input[name=foc_amount]').val("");
	$('input[name=special_discount]').val("");
	newRealtimeCalculation();
	$('#payment_sum, #payment').show();
	$('#payment_sum2').hide();

	card_query = $('input[name=card_query]').val();
	$.ajax({
		type	:	"POST",
		data	:	{command: "cardQuery", card_query: card_query},
		dataType:	"json",
		url		:	"ajax.php",
		success	:	function(data){
			// console.log(data);
			$('.card-login-user-box').html(data.user_show);
			$('#scanbox-card').html(data.show);
			pin_exist = $('input[name=pin]').length;
			code = data.code;
			doCardBoxClose();
			if(pin_exist){
				// SET SUBMIT PIN
				$('button.submit-pin').click(function(){
					button = $(this);
					pin = $(this).parent().find('input[name=pin]').val();
					card_no = $(this).parent().find('input[name=pin]').attr('card_no');
					parent_box = $(this).parent().parent().parent().parent();
					if(pin != ""){
						$.ajax({
							type	:	"post",
							data	:	{command: "submitPin", card_no: card_no, pin: pin},
							dataType:	"json",
							url		:	"ajax.php",
							success	:	function(data){
								// console.log(data);
								if(data.pass){
									closeAllDiscountRelateInput();
									button.parent().parent().parent().fadeOut(200, function(){
										$(this).remove();
										// console.log(data.show);
										// alert(parent_box.attr('class'));
										if(data.value.foc){
											$('#scanbox-card .box').hide();
										}
										parent_box.append(data.show).show();
										setCardInput();
										doCardBoxClose();

										// if(data.is_foc){
										if(data.value.foc){
											// $('#scanbox-card .box').remove();

											//do discount
											$('#payment_sum, #payment').hide();
											$('#payment_sum2').show();
											$('.discount_percent_input').val(data.value.foc_percent);
											use_service_charge = parseInt(data.value.service_charge);
											if(use_service_charge){
												$('input[name=cal_service_charge]').prop('checked', true);
											}else{
												$('input[name=cal_service_charge]').prop('checked', false);
											}
											newRealtimeCalculation();
										}
									});
								}else{
									alert(data.text);
								}
							}
						});
					}
				});
			}else{
				doCardBoxClose();
				setCardInput();
			}
			newRealtimeCalculation();
		}
	});
};

/**
 * ตอนที่กดปุ่ม login ในหน้า Add Payment
 */
function getMemberInventoryLogin(){
	member_query = $('input[name=card_query]').val();
	$.ajax({
		type	:	"POST",
		data	:	{command: "memberQuery", member_query: member_query},
		dataType:	"json",
		url		:	"ajax.php",
		success	:	function(data){
			$('#member-inventory-zone').html(data.show);

			// DELETE BUTTON
			$('#inventory-login .delete').click(function(){
				$('#inventory-login').remove();
			});

			// LOGIN BUTTON
			$('#inventory-login .submit-login').click(function(){
				// CLEAR MESSAGE
				$('#inventory-login .status').html('<i class="fas fa-spinner fa-spin fa-2x"></i>');

				// LOGIN SCRIPT
				member_id =  $('input[name=member_id]').val();
				member_password =  $('input[name=member_password]').val();
				loading();
				$.ajax({
					type	:	"POST",
					data	:	{command: "memberLogin", member_id: member_id, member_password: member_password},
					url		:	"ajax.php",
					success	:	function(pass){
						if(pass){
							order_id = $('input[name=order_id_array]').val();
							$('#inventory-login .status').html('<span class="press_title gold">Login Success</span>');
							$.ajax({
								type	:	"POST",
								data	:	{command: "bindMemberToOrder", order_id: order_id, member_id: member_id},
								dataType:	"json",
								url		:	"ajax.php",
								success	:	function(data){
									location.reload();
								}
							});

							// LOAD PAYMENT TYPE ON THE FLY
							page = $('input[name=page]').val();
							sub_page = $('input[name=sub_page]').val();
							if(page == 'product' || page == 'onsen'){
								getMemberPaymentType(member_id, page, sub_page);
							}
						}else{
							$('#inventory-login .status').html('<span class="press_title red">Wrong Password</span>');
						}
						unload();
					}
				});
			});
		}
	});
}

/**
 * สำหรับ Fancy Select อยากให้ทำอะไรให้ทำที่นี่
 */
function setFancySelect(){
	$('select.fancy').change(function(){
		select_val = $(this).val();
		select_class = $(this).find('option[value='+select_val+']').attr('data-select-class');
		$(this).attr('class', 'fancy '+select_val+' '+select_class);
	});
}

// ปุ่มกดให้ payment ออกมากกว่า 3 อัน
function showMorePayment(){
	$(".sub_group").removeClass("hide"); 
	$(".show_more_payment").remove();
}

/**
 * ใช้ในหน้า Sale ฝั่งที่กรอกข้อมูลลูกค้าแล้วต้องกดปุ่ม check
 */
function checkCustomerInfoInput(){
	telephone = $('#customer_telephone').val();
	email = $('#customer_email').val();
	$.ajax({
		type	:	"POST",
		url		:	"ajax.php",
		data	:	{command : "getMember", telephone: telephone, email: email},
		dataType:	"json",
		success	:	function(data){
			if(data.pass){
				if(handleBannedMember(data, '.status')){
					return;
				}
				Scan = new ScanAction;
				Scan.customer(data);
				$('.status').html('');
			}else{
				$('.status').html(data.message);
				handleBannedMember(null, '.status');
			}
		}
	});
}

function autoUser(){
	$('.auto_user').autocomplete({
		source: path+"ajax_autocomplete.php?type=user",
		minLength: 1,
		autoFocus: true,
		change:	function(event, ui){
		},
		select: function(event, ui){
			console.log(ui.item);
			user_id = ui.item.user_id;
			employee_code = ui.item.employee_code;
			$('input[name=staff_id]').val(user_id);
			$('input[name=employee_code]').val(employee_code);
		}
	});
	$('.auto_staff_salesperson').autocomplete({
		source: path+"ajax_autocomplete.php?type=staff_salesperson",
		minLength: 1,
		autoFocus: true,
		change:	function(event, ui){
		},
		select: function(event, ui){
			console.log(ui.item);
			user_id = ui.item.user_id;
			employee_code = ui.item.employee_code;
			$('input[name=staff_id]').val(user_id);
			$('input[name=employee_code]').val(employee_code);
		}
	});	
}
function autoEmployee(){
	$('.auto_employee_local').autocomplete({
		source: path+"ajax_autocomplete.php?type=local",
		minLength: 1,
		autoFocus: true,
		close:	function(){
		},
		change: function(){
		}
	});

	$('.auto_employee_queue').autocomplete({
		source: path+"ajax_autocomplete.php?type=queue",
		minLength: 1,
		autoFocus: true,
		close:	function(){
		},
		change: function(){
		}
	});
	
	$('.auto_employee').autocomplete({
		source: path+"ajax_autocomplete.php?type=all",
		minLength: 1,
		autoFocus: true,
		close:	function(){
		},
		change: function(){
		}
	});
}
function autoTherapist(){
	$('.auto_therapist').autocomplete({
		source: path+"ajax_autocomplete.php?type=all",
		minLength: 1,
		autoFocus: true,
		close:	function(){
			vars = $('#filter_form').serializeArray();
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	vars,
				beforeSend : function(){
					$('#report .dropzone').html("<div class='loading'></div>");
				},
				success	:	function(data){
					$('#report .dropzone').html(data);
				}
			});
		},
		select: function(event, ui){
			therapist_id = ui.item.therapist_id;
			employee_code = ui.item.employee_code;
			$('input[name=staff_id]').val(therapist_id);
			$('input[name=employee_code]').val(employee_code);
		}
	});
}
